import { validateTrafficCertificates } from '../utils/trafficCertificates';
import AdditionalTrafficCertificates from '../components/AdditionalTrafficCertificates';
import { isWhiteCardCertificate, isTrafficCertificate, certificateNumberSuffix, toCertificateNumber, certificateExpiryDate } from '../utils/whiteCardDocument';
import useRecordSelection from '../lib/useRecordSelection';
import SearchInput from '../components/ui/SearchInput';
import { formatDate as format, formatName, normalizeSearch, formatTime, formatPhone, formatEmail } from '../lib/format';
import PageContent from '../components/ui/PageContent';
import PageHeader from '../components/ui/PageHeader';
import { TableEmpty, Table, TableHead, TableRow, TableHeaderCell, TableCell } from '../components/ui/Table';
import FieldLabel from '../components/ui/FieldLabel';
import UiCheckbox from '../components/ui/Checkbox';
import UiInput from '../components/ui/Input';
import Textarea from '../components/ui/Textarea';
import Button from '../components/ui/Button';
import Tabs from '../components/ui/Tabs';
import FilterChip from '../components/ui/FilterChip';
import { beginDownloadProgress } from '../utils/downloadProgress';
import { capitaliseNameWords } from '../utils/names';
import SiteWorkerComments from '../components/SiteWorkerComments';
import { getAllocationDisplayAddress, getAllocationNavigationCoordinates } from '../utils/workerAllocationAddress';
import { useState, useEffect, useRef, useMemo } from 'react';
import { requestTimesheetLocation } from '../utils/timesheetLocation';
import WorkerSignatureInput from '../components/WorkerSignatureInput';
import WorkerShiftDateTime from '../components/WorkerShiftDateTime';
import Input from '../components/Input';
import Dropdown from '../components/Dropdown';
import { getDropdownLabel, getDropdownValue, getQuarterHoursFromTimes, postWithAuth, randomString } from '../common';
import { ContractorClassOptions, googleApiKey, HighRiskClassOptions, TrafficClassOptions, userTypes, workerStatuses, workerTypes } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import Header from "../components/Header";
import AutoComplete from "react-google-autocomplete";
import Sidebar from '../components/Sidebar';
import Section from '../components/Section';
import { PlusIcon, EditIcon, VerifiedIcon, XIcon, CopyIcon, TrashIcon, MailIcon, ResetIcon, CheckIcon, DownloadIcon, UsersIcon, ClockIcon, ArchiveIcon } from '../components/NavIcons';
import { toast } from 'react-toastify';
import useTableSort from '../components/useTableSort';
import MyCalendar from '../components/Calendar';
import MyDropzone from '../components/MyDropzone';
import MyDropzoneMulti from '../components/MyDropzoneMulti';
import { clearViewWorker } from '../redux/userReducer';
import { isSameMonth, parse, isValid } from 'date-fns';
import PdfViewer from '../components/PdfViewer';
import ModalComponent from '../components/Modal';
import SignatureCanvas from 'react-signature-canvas';
import Checkbox from '../components/Checkbox';
import InvoiceGenerator from '../components/InvoiceGenerator';
import TimesheetPdfGenerator from '../components/TimesheetPdfGenerator';
import LoadingPopup from '../components/LoadingPopup';
import ContractorRatesTable from '../components/ContractorRatesTable';
import EmployeeRatesTable from '../components/EmployeeRatesTable';
import { applyDefaultContractorRates, createEmptyContractorRates, createEmptyEmployeeRates, deriveLegacyRatesFromContractorRates, getWorkerRateStructures, inferWorkerUserType, normalizeContractorRates, normalizeEmployeeRates } from '../utils/workerRates';
import AllocationMarkerMap from '../components/AllocationMarkerMap';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CompactSuccessModal from '../components/CompactSuccessModal';
import { resolveStorageFileUrl } from '../storageUpload';
import { needsReview } from '../utils/workerReview';
import { heicToJpegObjectUrl, isHeicFile } from '../heicImage';
import { businessWallDateToIso, toBusinessWallDate } from '../utils/businessTime';
const getWorkerInitials = (name = '') => {
    const parts = String(name).trim().split(/\s+/).filter(Boolean)
    const first = parts[0]?.[0] || ''
    const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
    return `${first}${last}`.toUpperCase()
}

const formatWorkerName = (name = '') => String(name)
    .trim()
    .toLowerCase()
    .replace(/(^|[\s'-])([a-z])/g, (_, separator, letter) => `${separator}${letter.toUpperCase()}`)

const formatWorkerSiteAddress = value => {
    let address = String(value || '').trim()
    if (!address) return '-'
    address = address.replace(/\s*,?\s*Australia\s*$/i, '').trim()
    address = address.replace(/\s*,?\s*(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\s*,?\s*\d{4}\s*$/i, '').trim()
    address = address.replace(/\s*,?\s*\d{4}\s*$/i, '').trim()
    return address.replace(/,\s*$/, '') || '-'
}

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.mjs',
//     import.meta.url,
// ).toString();

const removeWhitespace = (value) => String(value || '').replace(/\s+/g, '')
const phonePattern = /(\+?\d[\d\s()-]{7,}\d)/
const hasValidMapCoordinates = (value) => Array.isArray(value) && value.length >= 2 && Number.isFinite(Number(value[0])) && Number.isFinite(Number(value[1]))
const getLicenceVerificationMeta = (verification) => {
    const state = String(verification?.state || '').trim()
    if (!state) {
        return { className: 'workersDirectoryStatus workersDirectoryStatusOther', label: 'Not checked yet' }
    }
    if (state === 'verified') {
        return { className: 'verifiedBadge', label: verification?.message || 'Verified' }
    }
    if (state === 'invalid' || state === 'not_found') {
        return { className: 'workersDirectoryStatus workersDirectoryStatusPending', label: verification?.message || 'Verification failed' }
    }
    return { className: 'workersDirectoryStatus workersDirectoryStatusOther', label: verification?.message || 'Verification unavailable' }
}

const licenceVerificationTypeLabels = {
    white_card: 'White card',
    traffic_control: 'Traffic management',
    high_risk_work: 'High risk work licence',
}

const licenceVerificationResponseKeys = {
    white_card: 'whiteCardVerification',
    traffic_control: 'trafficControlVerification',
    high_risk_work: 'highRiskVerification',
}

const buildRecheckFeedback = (verificationType, verificationRecord) => {
    const label = licenceVerificationTypeLabels[verificationType] || 'Licence'
    const state = String(verificationRecord?.state || '').trim()
    const message = verificationRecord?.message || ''

    if (state === 'verified') {
        return {
            title: `${label} verified`,
            message: message || `${label} matched successfully.`,
        }
    }

    return {
        title: `${label} rechecked`,
        message: message || 'No verification result returned.',
    }
}

const buildManualVerificationFeedback = (verificationType, manualState) => ({
    title: manualState === 'verified'
        ? `${licenceVerificationTypeLabels[verificationType] || 'Licence'} manually verified`
        : `${licenceVerificationTypeLabels[verificationType] || 'Licence'} manually marked unverified`,
    message: manualState === 'verified'
        ? 'Manual verification saved.'
        : 'Manual unverified status saved.',
})

const WorkerProfile = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const workerAllocationActionRef = useRef('')
    const workerAllocationTabRef = useRef('')

    const userInfo = useSelector((state) => state.user.user)
    const activeOrg = useSelector((state) => state.user.activeOrg)
    const activeOrgInfo = useSelector((state) => state.user.activeOrgInfo)
    const viewWorkerSet = useSelector((state) => state.user.viewWorker)

    const [workers, setWorkers] = useState([])
    const [clients, setClients] = useState([])
    const [timeSheets, setTimeSheets] = useState([])
    const [acceptedStatsDate, setAcceptedStatsDate] = useState(new Date())
    const [sites, setSites] = useState([])
    const [invoices, setInvoices] = useState([])
    const [workerLeaves, setWorkerLeaves] = useState([])
    const [workerAuditLogs, setWorkerAuditLogs] = useState([])
    const [workerAuditPage, setWorkerAuditPage] = useState(1)
    const [viewTimeSheet, setViewTimeSheet] = useState(false)
    const [downloadTimeSheet, setDownloadTimeSheet] = useState(null)
    const [downloadQueue, setDownloadQueue] = useState([])
    const [selectedTimeSheetIds, setSelectedTimeSheetIds] = useState([])
    const [fillingFor, setFillingFor] = useState([])
    const [workerSearch, setWorkerSearch] = useState('')
    const [workerTypeFilter, setWorkerTypeFilter] = useState('')
    const [workerInitialFilter, setWorkerInitialFilter] = useState('')
    const [workerListTab, setWorkerListTab] = useState('workers')
    const [workerDirectoryPage, setWorkerDirectoryPage] = useState(1)
    const requestedWorkerListTab = searchParams.get('tab')
    const [workerLeavesAccordionExpanded, setWorkerLeavesAccordionExpanded] = useState(true)


    const [viewingWorker, setViewingWorker] = useRecordSelection('fetchWorkers', activeOrg?.id, record => setWorkers(rows => rows.map(row => row.id === record.id ? record : row)))
    const [pendingWorkerScrollId, setPendingWorkerScrollId] = useState('')
    const workerListScrollPosition = useRef(null)

    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState(false)
    // Async work (uploads, refetches, audit logs) checks these before touching the
    // form, so a reply that lands after the admin opened another worker is dropped.
    const viewingWorkerIdRef = useRef('')
    viewingWorkerIdRef.current = viewingWorker?.id || ''
    const editingRef = useRef(false)
    editingRef.current = editing
    const [leaveLoading, setLeaveLoading] = useState(false)
    const [workerAuditLoading, setWorkerAuditLoading] = useState(false)
    const [openingDocument, setOpeningDocument] = useState(false)
    const [workerHistoryRows, setWorkerHistoryRows] = useState([])
    const [workerHistoryComments, setWorkerHistoryComments] = useState({})
    const [editingWorkerHistoryId, setEditingWorkerHistoryId] = useState('')
    const [workerHistorySavingId, setWorkerHistorySavingId] = useState('')
    const [workerHistoryPage, setWorkerHistoryPage] = useState(1)
    const [recheckingVerificationType, setRecheckingVerificationType] = useState('')
    const [manualVerificationAction, setManualVerificationAction] = useState('')

    useEffect(() => {
        // Public sign-ups used to have their own tab; they are now in Pending Review,
        // so an old link to that tab lands there instead of on an unselected tab.
        const tab = requestedWorkerListTab === 'public' ? 'pending' : requestedWorkerListTab
        if (['workers', 'pending', 'archived'].includes(tab)) {
            setWorkerListTab(tab)
        }
    }, [requestedWorkerListTab])

    const [leaveStartDate, setLeaveStartDate] = useState('')
    const [leaveEndDate, setLeaveEndDate] = useState('')
    const [leaveComments, setLeaveComments] = useState('')
    const [leaveTab, setLeaveTab] = useState('upcoming')
    const [editingLeave, setEditingLeave] = useState(null)
    const [leaveWorker, setLeaveWorker] = useState('')
    const [showLeaveForm, setShowLeaveForm] = useState(false)
    const workerRowRefs = useRef(new Map())
    const workerIdFromUrl = searchParams.get('workerId') || ''
    const showingWorkerAllocations = searchParams.get('view') === 'allocations'

    useEffect(() => {
        if (!showingWorkerAllocations) return
        window.setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }), 0)
    }, [showingWorkerAllocations])

    const workerById = useMemo(
        () => new Map(workers.map(worker => [worker.id, worker])),
        [workers]
    )
    const workerNameById = useMemo(
        () => new Map(workers.map(worker => [worker.id, formatWorkerName(formatName(`${worker.firstName || ''} ${worker.lastName || ''}`))])),
        [workers]
    )
    const clientNameById = useMemo(
        () => new Map(clients.map(client => [client.id, client.name || ''])),
        [clients]
    )
    const siteNameById = useMemo(
        () => new Map(sites.map(site => [site.id, site.name || ''])),
        [sites]
    )

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [dob, setDob] = useState('')
    const [abn, setAbn] = useState('')
    const [contactNo, setContactNo] = useState('')
    const [profilePic, setProfilePic] = useState('')
    const [address, setAddress] = useState('')
    const [coordinates, setCoordinates] = useState([])
    const [status, setStatus] = useState('')
    const [workerType, setWorkerType] = useState([])
    const [userType, setUserType] = useState('')
    const [abnNameOptions, setAbnNameOptions] = useState([])
    const [abnMatchedName, setAbnMatchedName] = useState('')
    const [abnVerified, setAbnVerified] = useState(false)


    const [accountName, setAccountName] = useState('')
    const [bankName, setBankName] = useState('')
    const [bsb, setBsb] = useState('')
    const [accountNumber, setAccountNumber] = useState('')


    const [emergencyFirstName, setEmergencyFirstName] = useState('')
    const [emergencyLastName, setEmergencyLastName] = useState('')
    const [emergencyContactNo, setEmergencyContactNo] = useState('')

    const [confirmMessage, setConfirmMessage] = useState('')
    const [leaveConfirmMessage, setLeaveConfirmMessage] = useState(null)
    const [successMessage, setSuccessMessage] = useState(null)
    const showSuccess = (message) => setSuccessMessage({ title: 'Success', message })
    // const [preExistingInjuries, setPreExistingInjuries] = useState('')
    // const [prescribedMedication, setPrescribedMedication] = useState('')
    // const [medicalConditions, setMedicalConditions] = useState('')
    // const [allergies, setAllergies] = useState('')

    const [preExistingInjuriesYN, setPreExistingInjuriesYN] = useState('No');
    const [preExistingInjuries, setPreExistingInjuries] = useState('');

    const [prescribedMedicationYN, setPrescribedMedicationYN] = useState('No');
    const [prescribedMedication, setPrescribedMedication] = useState('');

    const [medicalConditionsYN, setMedicalConditionsYN] = useState('No');
    const [medicalConditions, setMedicalConditions] = useState('');

    const [allergiesYN, setAllergiesYN] = useState('No');
    const [allergies, setAllergies] = useState('');
    const [medicalOther, setMedicalOther] = useState('');

    const [driverLicenceSavingSupported, setDriverLicenceSavingSupported] = useState(false)
    const [trafficCertificatesSupported, setTrafficCertificatesSupported] = useState(false)
    const [trafficControlCertificates, setTrafficControlCertificates] = useState([])
    const [driverLicence, setDriverLicence] = useState({ number: '', state: '', class: '', expiryDate: '', picture: '' })
    const changeDriverLicence = (field, value) => setDriverLicence(previous => ({ ...previous, [field]: value }))

    const [whiteCardLicenseNo, setWhiteCardLicenseNo] = useState('')
    const isWhiteCardCert = isWhiteCardCertificate(whiteCardLicenseNo)
    const [whiteCardStartDate, setWhiteCardStartDate] = useState('')
    const [whiteCardPicture, setWhiteCardPicture] = useState('')

    const [trafficControlLicenseNo, setTrafficControlLicenseNo] = useState('')
    const isTrafficCert = isTrafficCertificate(trafficControlLicenseNo)
    const [trafficControlClass, setTrafficControlClass] = useState([])
    const [trafficControlStartDate, setTrafficControlStartDate] = useState('')
    const [trafficControlPicture, setTrafficControlPicture] = useState('')

    const [highRiskLicenseNo, setHighRiskLicenseNo] = useState('')
    const [highRiskStartDate, setHighRiskStartDate] = useState('')
    const [highRiskClass, setHighRiskClass] = useState([])
    const [highRiskExpiryDate, setHighRiskExpiryDate] = useState('')
    const [highRiskPicture, setHighRiskPicture] = useState('')

    const [contractorLicenseNo, setContractorLicenseNo] = useState('')
    const [contractorStartDate, setContractorStartDate] = useState('')
    const [contractorClass, setContractorClass] = useState([])
    const [contractorExpiryDate, setContractorExpiryDate] = useState('')
    const [contractorPicture, setContractorPicture] = useState('')


    const [weekdayMorningsRate, setWeekDayMorningsRate] = useState('') // legacy compatibility
    const [weekdayNightsRate, setWeekDayNightsRate] = useState('') // legacy compatibility
    const [fridayNightRate, setFridayNightRate] = useState('') // legacy compatibility
    const [saturdayDayRate, setSaturdayDayRate] = useState('') // legacy compatibility
    const [saturdayNightRate, setSaturdayNightRate] = useState('') // legacy compatibility
    const [sundayDayRate, setSundayDayRate] = useState('') // legacy compatibility
    const [sundayNightRate, setSundayNightRate] = useState('') // legacy compatibility
    const [contractorRates, setContractorRates] = useState(createEmptyContractorRates())
    const [employeeRates, setEmployeeRates] = useState(createEmptyEmployeeRates())

    const [clockIn, setClockIn] = useState('')
    const [clockOut, setClockOut] = useState('')
    const [signOffOtherWorkers, setSignOffOtherWorkers] = useState(false)
    const [applySameWorkHours, setApplySameWorkHours] = useState(false)

    const [supervisorName, setSupervisorName] = useState('')
    const [supervisorSign, setSupervisorSign] = useState('')
    const [supervisorNotAvailable, setSupervisorNotAvailable] = useState(false)
    const [breakMinutes, setBreakMinutes] = useState('0')
    const [breakIncludedInPay, setBreakIncludedInPay] = useState(false)
    const [triggerStateUpdate, setTriggerStateUpdate] = useState(1) // Used to force recheck of signatureref isEmpty, as it only works on next state change.
    const signatureRef = useRef()
    const prevAbnRef = useRef('')
    const [sitePictures, setSitePictures] = useState([])
    const [showSiteImageUpload, setShowSiteImageUpload] = useState(false)
    const [sitePictureUploading, setSitePictureUploading] = useState(false)
    const [siteWorkerUploads, setSiteWorkerUploads] = useState([])
    const [workerTimesheetSections, setWorkerTimesheetSections] = useState({
        shiftDetails: true,
        mapMarker: true,
        workers: true,
        documents: true,
        timeEntry: true,
        otherWorkers: true,
        supervisorSignOff: true,
    })

    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)


    const [chosenInvoice, setChosenInvoice] = useState('')
    const [shouldUploadAndSendInvoice, setShouldUploadAndSendInvoice] = useState(false)

    const [uploading, setUploading] = useState(false)
    const [loadingMessage, setLoadingMessage] = useState('')

    const [additionalJobsModifyingInvoice, setAdditionalJobsModifyingInvoice] = useState()
    const [showAdditionalJobs, setShowAdditionalJobs] = useState(false)
    const [additionalJobs, setAdditionalJobs] = useState([])

    const [showEditAdditionalJob, setShowEditAdditionalJob] = useState(false)
    const [showAdditionalJobIndex, setShowAdditionalJobIndex] = useState(-1)
    const [additionalJobDescription, setAdditionalJobDescription] = useState('')
    const [additionalJobQuantity, setAdditionalJobQuantity] = useState('')
    const [additionalJobRate, setAdditionalJobRate] = useState('')
    const [additionalJobTime, setAdditionalJobTime] = useState('')

    const formatCurrency = (value) => `$${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    const parseInvoiceLineDateValue = (value) => {
        if (!value) return null
        if (value instanceof Date) {
            return isValid(value) ? value : null
        }

        const directDate = new Date(value)
        if (isValid(directDate)) {
            return directDate
        }

        let raw = String(value || '').trim()
        raw = raw.replace(/^\(/, '').replace(/\)$/, '')
        if (raw.includes(' - ')) {
            raw = raw.split(' - ')[0].trim()
        }

        const formats = [
            'dd/MMM/yyyy h:mm a',
            'dd/MMM/yyyy',
            'dd/MM/yyyy h:mm a',
            'dd/MM/yyyy',
            'EEE, d MMM yyyy',
        ]

        for (const fmt of formats) {
            const parsed = parse(raw, fmt, new Date())
            if (isValid(parsed)) {
                return parsed
            }
        }

        return null
    }

    // const [additionalJobTotal, setAdditionalJobTotal] = useState(0)
    // const [additionalJobGst, setAdditionalJobGst] = useState(0)


    const dispatch = useDispatch()

    const roundTo15Min = (date) => {
        const ms = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / ms) * ms);
    };

    const isFutureCalendarDate = (value) => {
        if (!value) return false
        const selectedDate = new Date(value)
        const today = toBusinessWallDate(new Date())
        return selectedDate.getFullYear() > today.getFullYear()
            || (selectedDate.getFullYear() === today.getFullYear() && selectedDate.getMonth() > today.getMonth())
            || (selectedDate.getFullYear() === today.getFullYear() && selectedDate.getMonth() === today.getMonth() && selectedDate.getDate() > today.getDate())
    }

    const isTodayDate = (value) => {
        if (!value) return true
        const selected = value instanceof Date ? value : new Date(value)
        const today = toBusinessWallDate(new Date())
        return selected.getFullYear() === today.getFullYear()
            && selected.getMonth() === today.getMonth()
            && selected.getDate() === today.getDate()
    }

    const handleShiftStartChange = (value) => {
        setClockIn(value)
        if (value && !isTodayDate(value)) {
            window.alert('Warning: Different start date selected.')
        }
    }

    const handleShiftEndChange = (value) => {
        setClockOut(value)
        if (value && !isTodayDate(value)) {
            window.alert('Warning: Different end date selected.')
        }
    }

    const getShiftDurationMs = (start, end) => {
        if (!start || !end) return 0
        return new Date(end).getTime() - new Date(start).getTime()
    }

    const capitalizeFirstLetter = (value) => {
        return capitaliseNameWords(value)
    }


    useEffect(() => {
        if (activeOrg) {
            fetchWorkers()
            fetchWorkerLeaves()
            if (activeOrg.role === 'worker') {
                fetchTimeSheet()
                fetchInvoices()
            }
        }
    }, [activeOrg])

    useEffect(() => {
        if (viewTimeSheet) {
            const businessNow = toBusinessWallDate(new Date())
            setClockIn(viewTimeSheet.clockIn ? toBusinessWallDate(viewTimeSheet.clockIn) : roundTo15Min(businessNow))
            setClockOut(viewTimeSheet.clockOut ? toBusinessWallDate(viewTimeSheet.clockOut) : viewTimeSheet.clockIn ? roundTo15Min(businessNow) : '')
            setSupervisorNotAvailable(!!viewTimeSheet.supervisorNotAvailable)
            setSupervisorSign(viewTimeSheet.supervisorSign)
            setSupervisorName(viewTimeSheet.supervisorName || '')
            setBreakMinutes(viewTimeSheet.breakMinutes !== undefined ? String(viewTimeSheet.breakMinutes) : '0')
            setBreakIncludedInPay(!!viewTimeSheet.breakIncludedInPay)
            setSitePictures([])
            setShowSiteImageUpload(false)
            setSiteWorkerUploads([])
            // Co-workers this worker already started signing off stay selected, so
            // saving the clock-out also clocks them out. Anyone whose own timesheet is
            // already complete is left out (the server would refuse them).
            const savedOthers = (Array.isArray(viewTimeSheet.fillingFor) ? viewTimeSheet.fillingFor : []).filter(otherUser => {
                const otherSheet = (viewTimeSheet.othersTimeSheets || []).find(sheet => sheet.userId === otherUser.id)
                return String(otherSheet?.status || '').toLowerCase() !== 'completed'
            })
            if (savedOthers.length > 0) {
                setFillingFor(savedOthers.map(otherUser => ({
                    ...otherUser,
                    clockIn: otherUser.clockIn ? toBusinessWallDate(otherUser.clockIn) : roundTo15Min(businessNow),
                    clockOut: otherUser.clockOut ? toBusinessWallDate(otherUser.clockOut) : otherUser.clockIn ? roundTo15Min(businessNow) : '',
                })))
            } else {
                setFillingFor([])
            }
            setSignOffOtherWorkers(!viewTimeSheet.clockOut && savedOthers.length > 0)
            setApplySameWorkHours(false)
        }
    }, [viewTimeSheet])

    const buildSignOffOtherWorkers = () => {
        if (!viewTimeSheet?.othersTimeSheets) {
            return []
        }
        return viewTimeSheet.othersTimeSheets
            .filter(other => other.status !== 'Completed')
            .map(other => ({
                id: other.userId,
                clockIn: '',
                clockOut: '',
                breakMinutes: '',
                breakIncludedInPay: false,
            }))
    }

    useEffect(() => {
        if (!signOffOtherWorkers || !applySameWorkHours) return
        setFillingFor(current => current.map(other => ({
            ...other,
            clockIn: clockIn ? new Date(clockIn) : '',
            clockOut: clockOut ? new Date(clockOut) : '',
            breakMinutes,
        })))
    }, [signOffOtherWorkers, applySameWorkHours, clockIn, clockOut, breakMinutes])

    useEffect(() => {
        const fetchSiteUploads = async () => {
            if (!viewTimeSheet?.chosenSite || !activeOrg?.id) {
                setSiteWorkerUploads([])
                return
            }
            try {
                const resp = await postWithAuth('fetchSites', { orgId: activeOrg.id, recordId: viewTimeSheet.chosenSite })
                if (resp && resp.err) {
                    toast.error(resp.err)
                    return
                }
                if (resp && resp.data) {
                    const site = resp.data[0]
                    const uploads = site?.workerUploads || []
                    const filtered = userInfo?.id ? uploads.filter(r => r.workerId === userInfo.id) : uploads
                    setSiteWorkerUploads(filtered)
                }
            } catch (e) {
                toast.error(e.message)
            }
        }

        fetchSiteUploads()
    }, [viewTimeSheet, activeOrg, userInfo])

    const handleUploadSitePicture = async () => {
        if (!viewTimeSheet?.chosenSite) {
            toast.error('Site not found for this timesheet')
            return
        }
        if (!sitePictures || sitePictures.length === 0) {
            toast.error('Please upload site images')
            return
        }
        try {
            setSitePictureUploading(true)
            const payload = {
                siteId: viewTimeSheet.chosenSite,
                orgId: activeOrg.id,
                pictures: sitePictures,
                date: new Date().toISOString(),
            }
            const resp = await postWithAuth('addSitePicture', payload)
            if (resp && resp.err) {
                toast.error(resp.err)
                setSitePictureUploading(false)
                return
            }
            showSuccess('Site image uploaded')
            setSitePictures([])
            setShowSiteImageUpload(false)
            setSitePictureUploading(false)
        } catch (e) {
            toast.error(e.message)
            setSitePictureUploading(false)
        }
    }

    const fetchWorkers = async () => {

        try {

            const resp = await postWithAuth('fetchWorkers', {
                listOnly: activeOrg?.role !== 'worker',
                orgId: activeOrg.id,
                includePublicSignups: activeOrg?.role === 'admin',
                includeArchived: activeOrg?.role === 'admin',
            })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            if (resp && resp.data) {
                setDriverLicenceSavingSupported(resp.capabilities?.driverLicence === true)
                setTrafficCertificatesSupported(resp.capabilities?.trafficCertificates === true)
                setWorkers(resp.data)
                return resp.data
            }
        } catch (e) {
            toast.error(e.message)
        }

        return []
    }

    // Reload one worker from the server so the form starts from their latest
    // submission instead of the copy the list loaded earlier. The reply is only
    // applied while that worker is still open and not being edited.
    const refreshViewingWorker = async (workerId) => {
        if (!workerId) return null
        const result = await postWithAuth('fetchWorkers', { orgId: activeOrg.id, recordId: workerId }, { force: true })
        if (result?.err) throw new Error(result.err)
        const latestWorker = result?.data?.[0]
        if (latestWorker && viewingWorkerIdRef.current === workerId && !editingRef.current) {
            setViewingWorker(latestWorker)
        }
        return latestWorker || null
    }

    const startEditingWorker = async (workerId = viewingWorker?.id) => {
        if (workerId) {
            setLoading(true)
            try {
                await refreshViewingWorker(workerId)
            } finally {
                setLoading(false)
            }
            if (viewingWorkerIdRef.current !== workerId) return
        }
        setEditing(true)
    }

    // An upload that finishes after the admin cancelled or opened another worker
    // must not land in the form that is showing now.
    const guardWorkerUpload = (setter) => {
        const workerId = viewingWorker?.id || ''
        return (doc) => {
            if (viewingWorkerIdRef.current !== workerId || !editingRef.current) return
            setter(doc)
        }
    }


    const fetchInvoices = async () => {

        try {

            const resp = await postWithAuth('fetchInvoices', { orgId: activeOrg.id })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            if (resp && resp.data) {
                setInvoices(resp.data)
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const fetchTimeSheet = async () => {

        try {

            const resp = await postWithAuth('fetchTimeSheet', { orgId: activeOrg.id })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            if (resp && resp.data) {
                setTimeSheets(resp.data)
                // toast.success('TimeSheets loaded')
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const fetchTimeSheetDetails = async ({ timeSheetId, allocationId }) => {
        const resp = await postWithAuth('fetchTimeSheet', { orgId: activeOrg.id, timeSheetId, allocationId })
        if (resp && resp.err) {
            throw new Error(resp.err)
        }
        return resp?.data || []
    }

    const openTimeSheet = async (timeSheetId) => {
        try {
            const [detailedTimeSheet] = await fetchTimeSheetDetails({ timeSheetId })
            if (!detailedTimeSheet) {
                toast.error('Timesheet not found.')
                return
            }
            setViewTimeSheet(detailedTimeSheet)
        } catch (e) {
            toast.error(e.message)
        }
    }

    const [fetchingDownload, setFetchingDownload] = useState(false)
    const fetchDownloadTimeSheet = async (timeSheetId) => {
        setFetchingDownload(true)
        try {
            const [detail] = await fetchTimeSheetDetails({ timeSheetId })
            if (!detail) throw new Error("Timesheet not found.")
            return [detail]
        } finally { setFetchingDownload(false) }
    }
    const startTimeSheetDownloadQueue = async (queue) => {
        if (!queue.length) {
            setDownloadQueue([])
            setDownloadTimeSheet(null)
            return
        }

        try {
            setDownloadQueue(queue)
            const [detailedTimeSheet] = await fetchDownloadTimeSheet(queue[0].id)
            setDownloadTimeSheet(detailedTimeSheet || null)
        } catch (e) {
            toast.error(e.message)
            setDownloadQueue([])
            setDownloadTimeSheet(null)
        }
    }

    const advanceTimeSheetDownloadQueue = async () => {
        const remaining = downloadQueue.slice(1)
        setDownloadQueue(remaining)

        if (!remaining.length) {
            setDownloadTimeSheet(null)
            return
        }

        try {
            const [detailedTimeSheet] = await fetchDownloadTimeSheet(remaining[0].id)
            setDownloadTimeSheet(detailedTimeSheet || null)
        } catch (e) {
            toast.error(e.message)
            setDownloadQueue([])
            setDownloadTimeSheet(null)
        }
    }

    const fetchWorkerLeaves = async () => {

        try {
            const resp = await postWithAuth('fetchWorkerLeaves', { orgId: activeOrg.id })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            if (resp && resp.data) {
                setWorkerLeaves(resp.data)
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const fetchWorkerAuditLogs = async (workerId) => {
        if (!workerId || !activeOrg?.id) {
            setWorkerAuditLogs([])
            return
        }
        try {
            setWorkerAuditLogs([])
            setWorkerAuditLoading(true)
            const resp = await postWithAuth('fetchWorkerAuditLogs', { workerId, orgId: activeOrg.id })
            // The admin may have opened another worker while this was loading.
            if (viewingWorkerIdRef.current !== workerId) return
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            setWorkerAuditLogs(resp?.data || [])
        } catch (e) {
            if (viewingWorkerIdRef.current !== workerId) return
            toast.error(e.message)
        } finally {
            if (viewingWorkerIdRef.current === workerId) setWorkerAuditLoading(false)
        }
    }

    const fetchWorkerHistory = async (workerId) => {
        if (!workerId || !activeOrg?.id) {
            setWorkerHistoryRows([])
            return
        }
        try {
            const resp = await postWithAuth('fetchTimeSheet', { orgId: activeOrg.id, userId: workerId })
            if (viewingWorkerIdRef.current !== workerId) return
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            const rows = (resp?.data || [])
                .sort((a, b) => new Date(b.workerResponseAt || b.date || 0) - new Date(a.workerResponseAt || a.date || 0))
            setWorkerHistoryRows(rows)
        } catch (e) {
            toast.error(e.message)
        }
    }

    const saveWorkerHistoryComment = async (timeSheetId) => {
        if (!timeSheetId || !activeOrg?.id) return
        try {
            setWorkerHistorySavingId(timeSheetId)
            const adminHistoryComment = workerHistoryComments[timeSheetId] || ''
            const resp = await postWithAuth('saveWorkerHistoryComment', { id: timeSheetId, orgId: activeOrg.id, adminHistoryComment })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            showSuccess('Worker history comment saved')
            fetchTimeSheet()
            fetchWorkerHistory(viewingWorker?.id || '')
            setEditingWorkerHistoryId('')
        } catch (e) {
            toast.error(e.message)
        } finally {
            setWorkerHistorySavingId('')
        }
    }

    useEffect(() => {
        if (viewWorkerSet) {
            setViewingWorker(viewWorkerSet)
            dispatch(clearViewWorker())
        }
    }, [viewWorkerSet])

    useEffect(() => {
        if (!workerIdFromUrl || workers.length === 0) return

        if (viewingWorker?.id === workerIdFromUrl) return

        const matchedWorker = workers.find(worker => worker.id === workerIdFromUrl)
        if (matchedWorker) {
            setViewingWorker(matchedWorker)
        }
    }, [workerIdFromUrl, workers, viewingWorker])

    // Close when the param disappears (browser Back).
    useEffect(() => {
        if (!workerIdFromUrl && viewingWorker?.id) {
            setEditing(false)
            setViewingWorker()
        }
    }, [workerIdFromUrl])

    useEffect(() => {
        if (activeOrg?.role !== 'worker' || showingWorkerAllocations || workerIdFromUrl || workers.length === 0) return

        const currentWorker = workers.find(worker => String(worker.id) === String(userInfo?.id))
            || workers.find(worker => worker.email && worker.email === userInfo?.email)
            || workers[0]
        if (!currentWorker?.id) return

        const nextParams = new URLSearchParams(searchParams)
        nextParams.set('workerId', currentWorker.id)
        setSearchParams(nextParams)
        setViewingWorker(currentWorker)
        window.scrollTo({ top: 0, behavior: 'auto' })
    }, [activeOrg?.role, showingWorkerAllocations, workerIdFromUrl, workers, userInfo?.id, userInfo?.email, searchParams, setSearchParams])

    useEffect(() => {
        if (viewingWorker || !pendingWorkerScrollId) return

        const row = workerRowRefs.current.get(pendingWorkerScrollId)
        if (!row) return

        row.scrollIntoView({ behavior: 'smooth', block: 'center' })
        setPendingWorkerScrollId('')
    }, [viewingWorker, pendingWorkerScrollId, workers, workerSearch, workerTypeFilter, workerListTab])

    useEffect(() => {
        if (viewingWorker) {
            setInformation()
        }
    }, [viewingWorker])

    useEffect(() => {
        setSelectedTimeSheetIds([])
    }, [viewingWorker, timeSheets])


    const companyPayload = activeOrgInfo ? {
        name: activeOrgInfo.name,
        address: activeOrgInfo.address,
        phone: removeWhitespace(activeOrgInfo.phone),
        email: activeOrgInfo.primaryEmail,
        abn: removeWhitespace(activeOrgInfo.abn),

        accountName: activeOrgInfo.accountName,
        bsb: removeWhitespace(activeOrgInfo.bsb),
        accountNumber: removeWhitespace(activeOrgInfo.accountNumber),

    } : {}

    const memoInvoice = useMemo(() => {

        if (chosenInvoice) {

            // For worker
            const matchingWorker = workers.find(r => r.id === chosenInvoice.worker.id)

            if (!matchingWorker) {
                toast.error('Worker no longer exists- using old worker data')

                return {
                    ...chosenInvoice,
                    company: companyPayload,
                }
            }
            return {
                ...chosenInvoice,
                company: companyPayload,
                worker: {
                    id: matchingWorker.id,
                    name: matchingWorker.firstName + ' ' + matchingWorker.lastName,
                    address: matchingWorker.address,
                    phone: removeWhitespace(matchingWorker.contactNo || matchingWorker.phone),
                    email: matchingWorker.email,
                    abn: removeWhitespace(matchingWorker.abn),

                    accountName: matchingWorker.accountName,
                    bsb: removeWhitespace(matchingWorker.bsb),
                    accountNumber: removeWhitespace(matchingWorker.accountNumber),
                },


            }
        }
    }, [chosenInvoice]);

    const leavesWithWorkers = useMemo(() => {
        return workerLeaves.map((leave) => {
            return {
                ...leave,
                workerName: workerNameById.get(leave.workerId) || ''
            }
        })
    }, [workerLeaves, workerNameById])

    const filteredLeaves = useMemo(() => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        return leavesWithWorkers.filter((leave) => {
            const endDate = new Date(leave.endDate)
            if (Number.isNaN(endDate.getTime())) {
                return leaveTab === 'upcoming'
            }
            if (leaveTab === 'past') {
                return endDate < today
            }
            return endDate >= today
        })
    }, [leavesWithWorkers, leaveTab])


    const setInformation = () => {
        setFirstName(viewingWorker.firstName || '')
        setLastName(viewingWorker.lastName || '')
        setEmail(viewingWorker.email || '')
        setAbn(removeWhitespace(viewingWorker.abn))
        setAbnVerified(!!viewingWorker.abnVerified)
        setAbnMatchedName(viewingWorker.abnVerifiedName || '')
        setAbnNameOptions(viewingWorker.abnVerifiedName ? [{ label: viewingWorker.abnVerifiedName, value: viewingWorker.abnVerifiedName }] : [])
        setDob(viewingWorker.dob || '')
        setAccountName(viewingWorker.accountName || '')
        setBankName(viewingWorker.bankName || '')
        setBsb(removeWhitespace(viewingWorker.bsb))
        setAccountNumber(removeWhitespace(viewingWorker.accountNumber))

        setAddress(viewingWorker.address || '')
        setStatus(viewingWorker.status || '')
        setWorkerType(Array.isArray(viewingWorker.workerType) ? viewingWorker.workerType : [])
        setUserType(inferWorkerUserType(viewingWorker))
        setCoordinates(viewingWorker.coordinates || [])
        setContactNo(removeWhitespace(viewingWorker.contactNo))
        setProfilePic(viewingWorker.profilePic || '')

        setEmergencyFirstName(viewingWorker.emergencyFirstName || '')
        setEmergencyLastName(viewingWorker.emergencyLastName || '')
        setEmergencyContactNo(viewingWorker.emergencyContactNo || '')

        // setPreExistingInjuries(viewingWorker.preExistingInjuries || '')
        // setPrescribedMedication(viewingWorker.prescribedMedication || '')
        // setMedicalConditions(viewingWorker.medicalConditions || '')
        // setAllergies(viewingWorker.allergies || '')

        // Pre-existing Injuries
        if (viewingWorker.preExistingInjuries && viewingWorker.preExistingInjuries.trim() !== '' && viewingWorker.preExistingInjuries.toLowerCase() !== 'no') {
            setPreExistingInjuriesYN('Yes');
            setPreExistingInjuries(viewingWorker.preExistingInjuries);
        } else {
            setPreExistingInjuriesYN('No');
            setPreExistingInjuries('');
        }

        // Prescribed Medications
        if (viewingWorker.prescribedMedication && viewingWorker.prescribedMedication.trim() !== '' && viewingWorker.prescribedMedication.toLowerCase() !== 'no') {
            setPrescribedMedicationYN('Yes');
            setPrescribedMedication(viewingWorker.prescribedMedication);
        } else {
            setPrescribedMedicationYN('No');
            setPrescribedMedication('');
        }

        // Medical Conditions
        if (viewingWorker.medicalConditions && viewingWorker.medicalConditions.trim() !== '' && viewingWorker.medicalConditions.toLowerCase() !== 'no') {
            setMedicalConditionsYN('Yes');
            setMedicalConditions(viewingWorker.medicalConditions);
        } else {
            setMedicalConditionsYN('No');
            setMedicalConditions('');
        }

        // Allergies
        if (viewingWorker.allergies && viewingWorker.allergies.trim() !== '' && viewingWorker.allergies.toLowerCase() !== 'no') {
            setAllergiesYN('Yes');
            setAllergies(viewingWorker.allergies);
        } else {
            setAllergiesYN('No');
            setAllergies('');
        }
        setMedicalOther(viewingWorker.medicalOther || '')


        setDriverLicence({ number: viewingWorker.driverLicenceNumber || '', state: viewingWorker.driverLicenceState || '', class: viewingWorker.driverLicenceClass || '', expiryDate: viewingWorker.driverLicenceExpiryDate || '', picture: viewingWorker.driverLicencePicture || '' })
        setWhiteCardLicenseNo(viewingWorker.whiteCardLicenseNo || '')
        setWhiteCardStartDate(viewingWorker.whiteCardStartDate || '')
        setWhiteCardPicture(viewingWorker.whiteCardPicture || '')

        setTrafficControlLicenseNo(viewingWorker.trafficControlLicenseNo || '')
        setTrafficControlClass(viewingWorker.trafficControlClass || [])
        setTrafficControlStartDate(viewingWorker.trafficControlStartDate || '')
        setTrafficControlPicture(viewingWorker.trafficControlPicture || '')
        setTrafficControlCertificates(viewingWorker.trafficControlCertificates || [])

        setHighRiskLicenseNo(viewingWorker.highRiskLicenseNo || '')
        setHighRiskClass(viewingWorker.highRiskClass || [])
        setHighRiskStartDate(viewingWorker.highRiskStartDate || '')
        setHighRiskExpiryDate(viewingWorker.highRiskExpiryDate || '')
        setHighRiskPicture(viewingWorker.highRiskPicture || '')

        setContractorLicenseNo(viewingWorker.contractorLicenseNo || '')
        setContractorClass(viewingWorker.contractorClass || [])
        setContractorStartDate(viewingWorker.contractorStartDate || '')
        setContractorExpiryDate(viewingWorker.contractorExpiryDate || '')
        setContractorPicture(viewingWorker.contractorPicture || '')



        const rateStructures = getWorkerRateStructures(viewingWorker)
        const legacyRates = deriveLegacyRatesFromContractorRates(rateStructures.contractorRates, viewingWorker.workerType || [])
        setContractorRates(rateStructures.contractorRates)
        setEmployeeRates(rateStructures.employeeRates)
        setWeekDayMorningsRate(legacyRates.weekdayMorningsRate || '')
        setWeekDayNightsRate(legacyRates.weekdayNightsRate || '')
        setFridayNightRate(legacyRates.fridayNightRate || '')
        setSaturdayDayRate(legacyRates.saturdayDayRate || '')
        setSaturdayNightRate(legacyRates.saturdayNightRate || '')
        setSundayDayRate(legacyRates.sundayDayRate || '')
        setSundayNightRate(legacyRates.sundayNightRate || '')
    }

    useEffect(() => {
        if (!editing) {
            prevAbnRef.current = abn
            return
        }
        if (prevAbnRef.current && prevAbnRef.current !== abn) {
            setAbnVerified(false)
            setAbnMatchedName('')
            setAbnNameOptions([])
        }
        prevAbnRef.current = abn
    }, [abn, editing])

    const handleAbnLookup = async () => {
        try {
            const sanitizedAbn = removeWhitespace(abn)
            const resp = await postWithAuth('lookupAbn', { abn: sanitizedAbn })

            if (resp && resp.err) {
                toast.error('Error looking up ABN')
                return
            }

            if (resp && resp.data) {
                const options = resp.data.options.map(r => ({ label: r, value: r }))
                setAbnNameOptions(options)
                if (options.length > 0) {
                    setAbnMatchedName(options[0].value)
                }
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const buildWorkerPayload = () => {
        validateTrafficCertificates(trafficControlLicenseNo, trafficControlClass, trafficControlCertificates)
        if (!trafficCertificatesSupported && JSON.stringify(trafficControlCertificates) !== JSON.stringify(viewingWorker.trafficControlCertificates || [])) throw new Error('Additional certificate saving requires the server update. Your changes have not been saved.')
        if (isTrafficCertificate(trafficControlLicenseNo) && trafficControlClass.length > 1) {
            throw new Error('Select one class for the traffic management certificate.')
        }
        const originalLicence = { number: viewingWorker.driverLicenceNumber || '', state: viewingWorker.driverLicenceState || '', class: viewingWorker.driverLicenceClass || '', expiryDate: viewingWorker.driverLicenceExpiryDate || '', picture: viewingWorker.driverLicencePicture || '' }
        if (!driverLicenceSavingSupported && JSON.stringify(driverLicence) !== JSON.stringify(originalLicence)) {
            throw new Error('Driver licence saving is not available yet. Your changes have not been saved.')
        }

        const normalizedContractorRates = viewingWorker.id
            ? normalizeContractorRates(contractorRates)
            : applyDefaultContractorRates(contractorRates, workerType, userType)
        const normalizedEmployeeRates = normalizeEmployeeRates(employeeRates)
        const legacyRates = deriveLegacyRatesFromContractorRates(normalizedContractorRates, workerType)

        return {
            id: viewingWorker.id,
            firstName,
            lastName,
            email,
            profilePic,
            abn: removeWhitespace(abn),
            abnVerified,
            abnVerifiedName: abnVerified ? abnMatchedName : '',
            accountName, bankName,
            bsb: removeWhitespace(bsb),
            accountNumber: removeWhitespace(accountNumber),
            dob,
            address,
            coordinates,
            contactNo: removeWhitespace(contactNo),

            emergencyFirstName,
            emergencyLastName,
            emergencyContactNo,

            // preExistingInjuries,
            // prescribedMedication,
            // medicalConditions,
            // allergies,

            preExistingInjuriesYN,
            preExistingInjuries,

            prescribedMedicationYN,
            prescribedMedication,

            medicalConditionsYN,
            medicalConditions,

            allergiesYN,
            allergies,
            medicalOther,

            driverLicenceNumber: driverLicence.number,
            driverLicenceState: driverLicence.state,
            driverLicenceClass: driverLicence.class,
            driverLicenceExpiryDate: driverLicence.expiryDate,
            driverLicencePicture: driverLicence.picture,

            whiteCardLicenseNo,
            whiteCardStartDate,
            whiteCardPicture,


            trafficControlLicenseNo,
            trafficControlClass,
            trafficControlStartDate,
            trafficControlPicture,
            trafficControlCertificates,

            highRiskLicenseNo,
            highRiskClass,
            highRiskStartDate,
            highRiskExpiryDate,
            highRiskPicture,

            contractorLicenseNo,
            contractorClass,
            contractorStartDate,
            contractorExpiryDate,
            contractorPicture,


            contractorRates: normalizedContractorRates,
            employeeRates: normalizedEmployeeRates,
            weekdayMorningsRate: legacyRates.weekdayMorningsRate,
            weekdayNightsRate: legacyRates.weekdayNightsRate,
            fridayNightRate: legacyRates.fridayNightRate,
            saturdayDayRate: legacyRates.saturdayDayRate,
            saturdayNightRate: legacyRates.saturdayNightRate,
            sundayDayRate: legacyRates.sundayDayRate,
            sundayNightRate: legacyRates.sundayNightRate,

            status: status || '',
            workerType: Array.isArray(workerType) ? workerType : [],
            userType: userType || '',
            archived: !!viewingWorker?.archived,

            orgId: activeOrg.id,
        }
    }

    const handleVerifyAbn = async () => {
        if (!abnMatchedName) {
            toast.error('Select a matching name before verifying')
            return
        }
        // saveWorkerInfo stores the whole profile, so only verify once the form
        // holds the saved profile; otherwise unsaved edits would be saved with it.
        if (editing) {
            toast.error('Save or cancel your changes before verifying the ABN')
            return
        }
        const previousAbnVerified = abnVerified
        const workerId = viewingWorker?.id
        try {
            setLoading(true)
            const payload = { ...buildWorkerPayload(), abnVerified: true, abnVerifiedName: abnMatchedName }
            const resp = await postWithAuth('saveWorkerInfo', payload)
            if (resp && resp.err) {
                toast.error(resp.err)
                setAbnVerified(previousAbnVerified)
                return
            }
            if (viewingWorkerIdRef.current === workerId) {
                setAbnVerified(true)
                setViewingWorker({ ...viewingWorker, ...payload })
            }
            showSuccess('ABN verified')
        } catch (e) {
            toast.error(e.message)
            setAbnVerified(previousAbnVerified)
        } finally {
            setLoading(false)
        }
    }

    const handleSaveWorkerInfo = async () => {
        if (uploading) return

        try {
            setLoading(true)

            const payload = buildWorkerPayload()

            const resp = await postWithAuth('saveWorkerInfo', payload)
            if (resp?.err) throw new Error(resp.err)
            const savedWorkerId = viewingWorker.id || resp.data

            setEditing(false)
            setPendingWorkerScrollId(savedWorkerId)
            setSuccessMessage({
                title: 'Worker saved',
                message: 'Worker information saved successfully.',
            })
            await fetchWorkers()
            closeWorkerPanel(savedWorkerId)
            setLoading(false)

        } catch (e) {
            toast.error(e.message)
            setLoading(false)
        }
    }

    const handleRecheckVerification = async (verificationType) => {
        // Refreshing the worker resets the form, which would wipe unsaved edits.
        if (!viewingWorker?.id || !activeOrg?.id || editing) return

        try {
            setRecheckingVerificationType(verificationType)
            const resp = await postWithAuth('recheckWorkerVerifications', {
                workerId: viewingWorker.id,
                orgId: activeOrg.id,
                verificationTypes: [verificationType],
            })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            const updatedWorkers = await fetchWorkers()
            const updatedWorker = (updatedWorkers || []).find(worker => worker.id === viewingWorker.id)
            if (updatedWorker && viewingWorkerIdRef.current === updatedWorker.id && !editingRef.current) {
                setViewingWorker(updatedWorker)
            }
            const verificationRecord = resp?.data?.[licenceVerificationResponseKeys[verificationType]]
            const feedback = buildRecheckFeedback(verificationType, verificationRecord)
            setSuccessMessage(feedback)
        } catch (e) {
            toast.error(e.message)
        } finally {
            setRecheckingVerificationType('')
        }
    }

    const handleManualVerification = async (verificationType, manualState) => {
        if (!viewingWorker?.id || !activeOrg?.id || editing) return
        const actionKey = `${verificationType}:${manualState}`
        try {
            setManualVerificationAction(actionKey)
            const resp = await postWithAuth('setWorkerVerificationOverride', {
                workerId: viewingWorker.id,
                orgId: activeOrg.id,
                verificationType,
                manualState,
            })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            const updatedWorkers = await fetchWorkers()
            const updatedWorker = (updatedWorkers || []).find(worker => worker.id === viewingWorker.id)
            if (updatedWorker && viewingWorkerIdRef.current === updatedWorker.id && !editingRef.current) {
                setViewingWorker(updatedWorker)
            }
            setSuccessMessage(buildManualVerificationFeedback(verificationType, manualState))
        } catch (e) {
            toast.error(e.message)
        } finally {
            setManualVerificationAction('')
        }
    }

    // A multi-day card: rejecting asks whether it is for that day only or every day.
    const rejectDayLabel = value => {
        const date = value ? new Date(value) : null
        return date && !Number.isNaN(date.getTime()) ? format(date, 'EEE d MMM') : 'this day'
    }
    const confirmRejectAllocation = timeSheet => {
        const multiDay = !!timeSheet?.isGroupRow && Number(timeSheet?.groupDayCount || 0) > 1
        setConfirmMessage({
            message: 'Reject this allocation?',
            rejectChoices: multiDay ? [
                { value: 'day', label: `Just ${rejectDayLabel(timeSheet.date)}` },
                { value: 'all', label: `All ${timeSheet.groupDayCount} days (${rejectDayLabel(timeSheet.pendingFirstDate)} – ${rejectDayLabel(timeSheet.pendingLastDate)})` },
            ] : null,
            action: scope => handleRespondAllocation(timeSheet, 'Reject', scope),
        })
    }

    const handleRespondAllocation = async (timeSheet, timeSheetResponse, rejectScope = '') => {
        try {
            setLoading(true)
            setLoadingMessage('Saving allocation response...')
            const payload = {
                id: timeSheet?.id,
                timeSheetResponse,
                applyToGroup: !!timeSheet?.isGroupRow,
                rejectAllDays: timeSheetResponse === 'Reject' && rejectScope === 'all',
                orgId: activeOrg.id,
            }

            const resp = await postWithAuth('respondTimeSheet', payload)
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            showSuccess(timeSheetResponse === 'Accept'
                ? 'Allocation accepted successfully.'
                : rejectScope === 'all' ? `All ${timeSheet.groupDayCount} days rejected successfully.`
                    : rejectScope === 'day' ? `${rejectDayLabel(timeSheet.date)} rejected successfully.`
                        : 'Allocation rejected successfully.')
            fetchTimeSheet()
            setConfirmMessage()
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLoadingMessage('')
            setLoading(false)
        }
    }

    const copyText = async (value, label) => {
        if (!value) return
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(value)
            } else {
                const textarea = document.createElement('textarea')
                textarea.value = value
                textarea.style.position = 'fixed'
                textarea.style.opacity = '0'
                document.body.appendChild(textarea)
                textarea.select()
                document.execCommand('copy')
                document.body.removeChild(textarea)
            }
            showSuccess(`${label} copied`)
        } catch (e) {
            toast.error('Failed to copy')
        }
    }

    const closeWorkerPanel = (workerId = '') => {
        if (workerId && workerListScrollPosition.current === null) {
            setPendingWorkerScrollId(workerId)
        }
        if (workerIdFromUrl) {
            const nextParams = new URLSearchParams(searchParams)
            nextParams.delete('workerId')
            setSearchParams(nextParams)
        }
        setEditing(false)
        setViewingWorker()
        if (workerListScrollPosition.current !== null) {
            const savedScrollPosition = workerListScrollPosition.current
            workerListScrollPosition.current = null
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    window.scrollTo({ top: savedScrollPosition, behavior: 'auto' })
                })
            })
        }
    }

    const openWorkerPanel = (worker, startEditing = false) => {
        workerListScrollPosition.current = window.scrollY
        if (!worker?.id) {
            setViewingWorker(worker)
            window.scrollTo({ top: 0, behavior: 'smooth' })
            if (startEditing) setEditing(true)
            return
        }

        const nextParams = new URLSearchParams(searchParams)
        nextParams.set('workerId', worker.id)
        setSearchParams(nextParams)
        setEditing(false)
        setViewingWorker(worker)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        // The list copy can be older than the worker's own latest submission.
        if (startEditing) startEditingWorker(worker.id)
        else refreshViewingWorker(worker.id)
    }

    const buildWorkerDetailsText = (worker) => {
        const dobValue = worker?.dob ? format(new Date(worker.dob), 'EEE, d MMM yyyy') : ''
        return formatName([
            `First Name: ${worker?.firstName || ''}`,
            `Last Name: ${worker?.lastName || ''}`,
            `Contact Number: ${worker?.contactNo || ''}`,
            `Email: ${worker?.email || ''}`,
            `DOB: ${dobValue}`,
        ].join('\n'))
    }

    const openConfidentialFile = async (file, label, downloading = false) => {
        if (!file) return
        // Open the tab now, while the click still counts as a user gesture; popup
        // blockers stop a window opened after the awaits below.
        const popup = window.open('', '_blank')
        if (popup) popup.opener = null
        const showInPopup = (url) => {
            if (popup && !popup.closed) {
                popup.location.href = url
                return
            }
            const opened = window.open(url, '_blank', 'noopener,noreferrer')
            if (!opened && !popup) {
                toast.error(`Your browser blocked the ${label} from opening. Allow pop-ups for this site and try again.`)
            }
        }
        const finishDownload = downloading ? beginDownloadProgress() : null
        if (!downloading) setOpeningDocument(true)
        try {
            const resolvedUrl = await resolveStorageFileUrl(file, activeOrg?.id || '')
            if (!resolvedUrl) {
                throw new Error('Missing file url')
            }
            if (isHeicFile(file)) {
                // Opening the raw HEIC would hand the admin a file most Windows
                // machines cannot open, so give them a JPEG instead.
                const jpegUrl = await heicToJpegObjectUrl(resolvedUrl)
                showInPopup(jpegUrl)
                setTimeout(() => URL.revokeObjectURL(jpegUrl), 60000)
                return
            }
            showInPopup(resolvedUrl)
        } catch (e) {
            if (popup && !popup.closed) popup.close()
            toast.error(`Unable to open ${label}`)
        } finally {
            setOpeningDocument(false)
            finishDownload?.()
        }
    }

    const submitTimeSheetSave = async ({ breakValue }) => {
        const locationCoordinates = isWorker
            ? await requestTimesheetLocation()
            : undefined
        const payload = {
            id: viewTimeSheet.id,
            clockIn: businessWallDateToIso(clockIn),
            clockOut: businessWallDateToIso(clockOut) || '',
            supervisorName,
            supervisorNotAvailable,
            breakMinutes: breakValue,
            fillingFor: signOffOtherWorkers
                ? fillingFor.filter(otherUser => otherUser.clockIn).map(otherUser => ({ ...otherUser, breakIncludedInPay: !!viewTimeSheet.breakIncludedInPay, timeSheetId: viewTimeSheet.othersTimeSheets.find(x => x.userId === otherUser.id)?.id, clockIn: businessWallDateToIso(otherUser.clockIn), clockOut: businessWallDateToIso(otherUser.clockOut) || '', }))
                : [],
            breakIncludedInPay: !!breakIncludedInPay,
            orgId: activeOrg.id,
            ...(locationCoordinates ? { locationCoordinates } : {}),
        }

        let signPayload = {}

        if (mobileWorkerTimesheet && !supervisorNotAvailable) {
            signPayload = { supervisorSign }
        } else if (!supervisorNotAvailable && !viewTimeSheet.clockOut) {
            signPayload = {
                supervisorSign: signatureRef.current.getTrimmedCanvas().toDataURL('image/png')
            }
        } else if (!supervisorNotAvailable && supervisorSign) {
            signPayload = {
                supervisorSign
            }
        }

        const response = await postWithAuth('saveTimeSheet', { ...payload, ...signPayload })
        if (response?.err) throw new Error(response.err)
        showSuccess('Timesheet information saved')
        setViewTimeSheet()
        fetchTimeSheet()
    }


    const handleSaveTimeSheet = async () => {


        try {
            setLoading(true)
            const breakValue = Number(breakMinutes) || 0;
            if (breakValue < 0 || breakValue % 15 !== 0) {
                toast.error('Break duration must be a non-negative multiple of 15 minutes.')
                setLoading(false)
                return
            }
            if (clockIn && clockOut && clockOut <= clockIn) {
                toast.error('Clock out time must be after clock in time.')
                setLoading(false)
                return
            }
            if (clockIn && clockOut && (new Date(clockOut).getTime() - new Date(clockIn).getTime()) < 4 * 60 * 60 * 1000) {
                toast.error('Change finish time. Minimum 4 hour shift required.')
                setLoading(false)
                return
            }
            if (signOffOtherWorkers && fillingFor.some(otherUser => !otherUser.clockIn)) {
                toast.error('Enter a shift start for each worker you are signing off, or untick them.')
                setLoading(false)
                return
            }
            const invalidFillingFor = fillingFor.find(otherUser => otherUser.clockIn && otherUser.clockOut && otherUser.clockOut <= otherUser.clockIn)
            if (invalidFillingFor) {
                const name = formatName(`${invalidFillingFor.firstName || ''} ${invalidFillingFor.lastName || ''}`).trim() || 'Filling for worker'
                toast.error(`${name}: clock out time must be after clock in time.`)
                setLoading(false)
                return
            }
            const invalidMinimumShift = fillingFor.find(otherUser => otherUser.clockIn && otherUser.clockOut && (new Date(otherUser.clockOut).getTime() - new Date(otherUser.clockIn).getTime()) < 4 * 60 * 60 * 1000)
            if (invalidMinimumShift) {
                const name = formatName(`${invalidMinimumShift.firstName || ''} ${invalidMinimumShift.lastName || ''}`).trim() || 'Filling for worker'
                toast.error(`${name}: Change finish time. Minimum 4 hour shift required.`)
                setLoading(false)
                return
            }
            if (isFutureCalendarDate(clockIn)) {
                toast.error('Change shift start/end date. Cannot be a future date.')
                setLoading(false)
                return
            }
            if (isFutureCalendarDate(clockOut)) {
                toast.error('Change shift start/end date. Cannot be a future date.')
                setLoading(false)
                return
            }
            const invalidFutureShift = fillingFor.find(otherUser => isFutureCalendarDate(otherUser.clockIn) || isFutureCalendarDate(otherUser.clockOut))
            if (invalidFutureShift) {
                const name = formatName(`${invalidFutureShift.firstName || ''} ${invalidFutureShift.lastName || ''}`).trim() || 'Filling for worker'
                toast.error(`${name}: change shift start/end date. Cannot be a future date.`)
                setLoading(false)
                return
            }

            if (getShiftDurationMs(clockIn, clockOut) > 13 * 60 * 60 * 1000) {
                setLoading(false)
                setConfirmMessage({
                    title: 'Warning.',
                    message: 'Shift greater than 13 hours. Check your hours before saving.',
                    confirmLabel: 'Save Anyway',
                    cancelLabel: 'Update Times',
                    action: async () => {
                        setConfirmMessage()
                        try {
                            setLoading(true)
                            await submitTimeSheetSave({ breakValue })
                        } catch (e) {
                            toast.error(e.message)
                        } finally {
                            setLoading(false)
                        }
                    }
                })
                return
            }

            await submitTimeSheetSave({ breakValue })
            setLoading(false)

        } catch (e) {
            toast.error(e.message)
            setLoading(false)
        }
    }

    const clearLeaveForm = () => {
        setEditingLeave(null)
        setLeaveStartDate('')
        setLeaveEndDate('')
        setLeaveComments('')
        setLeaveWorker('')
        setShowLeaveForm(false)
    }

    const handleEditLeave = (leave) => {
        setEditingLeave(leave)
        setLeaveStartDate(toBusinessWallDate(leave.startDate) || '')
        setLeaveEndDate(toBusinessWallDate(leave.endDate) || '')
        setLeaveComments(leave.comments || '')
        setLeaveWorker(getDropdownValue(leave.workerId, workers.map(r => ({ label: formatName(`${r.firstName} ${r.lastName}`), value: r.id }))))
        setShowLeaveForm(true)
    }

    const handleSaveLeave = async () => {
        if (!activeOrg) {
            toast.error('No active organisation selected')
            return
        }

        if (!leaveStartDate || !leaveEndDate) {
            toast.error('Please select a start and end date')
            return
        }
        if (isAdmin && !editingLeave && !leaveWorker) {
            toast.error('Please select a worker')
            return
        }

        const startDate = new Date(leaveStartDate)
        const endDate = new Date(leaveEndDate)

        if (endDate < startDate) {
            toast.error('Leave end date must be the same as or after the start date')
            return
        }

        setLeaveLoading(true)

        try {
            const payload = {
                id: editingLeave?.id,
                workerId: editingLeave?.workerId || leaveWorker?.value || userInfo?.id,
                startDate: businessWallDateToIso(startDate),
                endDate: businessWallDateToIso(endDate),
                comments: leaveComments,
                orgId: activeOrg.id
            }

            const resp = await postWithAuth('saveWorkerLeave', payload)

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            showSuccess(editingLeave ? 'Leave updated' : 'Leave created')
            clearLeaveForm()
            fetchWorkerLeaves()
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLeaveLoading(false)
        }
    }

    const handleDeleteLeave = async (leave) => {
        if (!leave?.id || !activeOrg) {
            setLeaveConfirmMessage(null)
            return
        }

        setLeaveLoading(true)

        try {
            const resp = await postWithAuth('deleteWorkerLeave', {
                id: leave.id,
                orgId: activeOrg.id
            })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            showSuccess('Leave deleted')
            if (editingLeave?.id === leave.id) {
                clearLeaveForm()
            }
            fetchWorkerLeaves()
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLeaveLoading(false)
            setLeaveConfirmMessage(null)
        }
    }

    const handleResendSignUpEmail = async (worker) => {

        try {
            setLoading(true)


            const payload = {
                id: worker.id,
                orgId: activeOrg.id,
            }

            const resp = await postWithAuth('resendSignUpEmail', { ...payload })

            if (resp && resp.err) {
                toast.error(resp.err)
                setLoading(false)
                return
            }

            if (resp && resp.data) {
                showSuccess('Sign-up email resent')
                setLoading(false)
                fetchWorkers()
            }
        } catch (e) {
            toast.error(e.message)
            setLoading(false)
        }
    }

    const handleApproveReview = async (worker) => {
        try {
            setLoading(true)
            const resp = await postWithAuth('approveWorkerReview', {
                id: worker.id,
                orgId: activeOrg.id,
            })

            if (resp && resp.err) {
                toast.error(resp.err)
                setLoading(false)
                return
            }

            const { signupApproved, profileApproved } = resp?.data || {}
            showSuccess(signupApproved && profileApproved
                ? 'Signup and profile approved'
                : signupApproved
                    ? 'Signup approved. They can now be allocated shifts.'
                    : 'Profile approved')
            // Stay on the current tab: from the review queue the admin usually
            // wants the next worker, not the full directory.
            const updatedWorkers = await fetchWorkers()
            const updatedWorker = updatedWorkers.find(row => row.id === worker.id)
            if (viewingWorker?.id === worker.id && updatedWorker) {
                setViewingWorker(updatedWorker)
            }
            setLoading(false)
        } catch (e) {
            toast.error(e.message)
            setLoading(false)
        }
    }

    const handleArchiveWorker = async (worker) => {
        try {
            setLoading(true)
            const resp = await postWithAuth('archiveWorker', {
                id: worker.id,
                orgId: activeOrg.id,
            })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            showSuccess('Worker archived')
            setWorkerListTab('archived')
            const updatedWorkers = await fetchWorkers()
            const updatedWorker = updatedWorkers.find(row => row.id === worker.id)
            if (updatedWorker) {
                setViewingWorker(updatedWorker)
            }
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLoading(false)
            setConfirmMessage('')
        }
    }

    const handleRestoreWorker = async (worker) => {
        try {
            setLoading(true)
            const resp = await postWithAuth('restoreWorker', {
                id: worker.id,
                orgId: activeOrg.id,
            })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            showSuccess('Worker restored')
            setWorkerListTab('workers')
            const updatedWorkers = await fetchWorkers()
            const updatedWorker = updatedWorkers.find(row => row.id === worker.id)
            if (updatedWorker) {
                setViewingWorker(updatedWorker)
            }
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLoading(false)
            setConfirmMessage('')
        }
    }

    const handleDeleteWorker = async (worker) => {
        try {
            setLoading(true)
            const resp = await postWithAuth('deleteWorker', {
                id: worker.id,
                orgId: activeOrg.id,
            })
            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }
            showSuccess('Worker deleted')
            setViewingWorker('')
            setEditing(false)
            setWorkerListTab('workers')
            await fetchWorkers()
        } catch (e) {
            toast.error(e.message)
        } finally {
            setLoading(false)
            setConfirmMessage('')
        }
    }

    const handleSendInvoice = async (url) => {

        let payload = {
            id: chosenInvoice.id,
            url,
            invoiceNumber: chosenInvoice.invoiceNumber,
        }

        const resp = await postWithAuth('workerSignsInvoice', {
            ...payload,
            orgId: activeOrg.id
        })

        if (resp && resp.err) {
            toast.error(resp.err)
            return
        }

        if (resp && resp.data) {
            showSuccess('Invoice sent')
            fetchInvoices()
            setShouldUploadAndSendInvoice(false)
        }
    }

    // const calculateAdditionalJobRowSubTotal = (row) => {
    //     let totalRow = 0
    //     if (row) {
    //         totalRow = parseFloat(row.additionalJobRate || 0) * parseFloat(row.additionalJobQuantity || 0)
    //     } else {
    //         totalRow = parseFloat(additionalJobRate || 0) * parseFloat(additionalJobQuantity || 0)
    //     }

    //     if (totalRow >= 0) {
    //         return totalRow
    //     }
    //     return 0
    // }


    const clearJobRateFields = () => {
        setAdditionalJobDescription('')
        // setAdditionalJobGst(0)
        setAdditionalJobRate('')
        // setAdditionalJobTotal(0)
        setAdditionalJobTime('')
        setAdditionalJobQuantity('')
    }


    const calculateAdditionalJobRowSubTotal = (row) => {
        let totalRow = 0
        if (row) {
            totalRow = parseFloat(row.rate || 0) * parseFloat(row.quantity || 0)
        } else {
            totalRow = parseFloat(additionalJobRate || 0) * parseFloat(additionalJobQuantity || 0)
        }

        if (totalRow >= 0) {
            return totalRow
        }
        return 0
    }

    const calculateAdditionalJobRowGst = (row) => {
        let totalRow = 0
        if (row) {
            totalRow = parseFloat(row.rate || 0) * parseFloat(row.quantity || 0)
        } else {
            totalRow = parseFloat(additionalJobRate || 0) * parseFloat(additionalJobQuantity || 0)
        }

        if (totalRow >= 0) {
            return totalRow * 0.1
        }
        return 0
    }

    const handleSaveEditAdditionalJob = () => {
        const resolvedAdditionalJobTime = parseInvoiceLineDateValue(additionalJobTime) || new Date()
        setAdditionalJobs([...additionalJobs.map((r, idx) => idx === showAdditionalJobIndex ? { ...r, description: additionalJobDescription, rate: additionalJobRate, quantity: additionalJobQuantity, time: format(resolvedAdditionalJobTime, 'dd/MMM/yyyy'), gst: calculateAdditionalJobRowGst(), total: calculateAdditionalJobRowSubTotal() + calculateAdditionalJobRowGst(), subtotal: calculateAdditionalJobRowSubTotal() } : r)])
        setShowEditAdditionalJob(false)
    }

    const handleEditJob = (row, index) => {
        setAdditionalJobDescription(row.description)
        // setAdditionalJobGst()
        // setAdditionalJobTotal(0)
        setAdditionalJobRate(row.rate)
        setAdditionalJobTime(parseInvoiceLineDateValue(row.time) || '')
        setAdditionalJobQuantity(row.quantity)
        setShowAdditionalJobIndex(index)
        setShowEditAdditionalJob(true)
    }

    // should update invoice subtotal, total and gst records. Then when user clicks send will generate invoice and send to owner.
    const handleSaveAdditionalJobs = async () => {

        let payload = {
            id: additionalJobsModifyingInvoice.id,
            additionalJobs,
        }


        try {

            const resp = await postWithAuth('workerUpdatesInvoice', {
                ...payload,
                orgId: activeOrg.id
            })

            if (resp && resp.err) {
                toast.error(resp.err)
                return
            }

            if (resp && resp.data) {
                showSuccess('Invoice updated. Please send it for approval.')
                setShowAdditionalJobs(false)
                fetchInvoices()
            }
        } catch (e) {
            toast.error(e.message)
        }



    }

    const filteredWorkers = useMemo(() => workers.filter(worker => {
        const searchValue = normalizeSearch(workerSearch.trim())
        const fullName = formatName(`${worker.firstName || ''} ${worker.lastName || ''}`).trim().toLowerCase()
        const matchesSearch = !searchValue
            || fullName.includes(searchValue)
            || normalizeSearch(String(worker.contactNo || '')).includes(searchValue)
            || normalizeSearch(String(worker.email || '')).includes(searchValue)
        const workerTypeValues = Array.isArray(worker.workerType) ? worker.workerType : []
        const matchesWorkerType = !workerTypeFilter || workerTypeValues.includes(workerTypeFilter)
        const matchesInitial = !workerInitialFilter || String(worker.firstName || '').trim().toUpperCase().startsWith(workerInitialFilter)
        return matchesSearch && matchesWorkerType && matchesInitial
    }), [workers, workerSearch, workerTypeFilter, workerInitialFilter])
    const archivedWorkers = useMemo(() => filteredWorkers.filter(worker => worker.archived), [filteredWorkers])
    const pendingWorkers = useMemo(() => filteredWorkers.filter(needsReview), [filteredWorkers])
    const visibleWorkers = workerListTab === 'pending'
        ? pendingWorkers
        : workerListTab === 'archived'
            ? archivedWorkers
            : filteredWorkers
    const workersSort = useTableSort(visibleWorkers, { key: 'firstName', direction: 'ascending' });
    const workerDirectoryPageSize = 20
    const workerDirectoryPageCount = Math.max(1, Math.ceil(workersSort.sortedData.length / workerDirectoryPageSize))
    const paginatedWorkerRows = useMemo(() => {
        const firstRow = (workerDirectoryPage - 1) * workerDirectoryPageSize
        return workersSort.sortedData.slice(firstRow, firstRow + workerDirectoryPageSize)
    }, [workersSort.sortedData, workerDirectoryPage])

    useEffect(() => {
        setWorkerDirectoryPage(1)
    }, [workerListTab, workerSearch, workerTypeFilter, workerInitialFilter])

    useEffect(() => {
        setWorkerDirectoryPage(currentPage => Math.min(currentPage, workerDirectoryPageCount))
    }, [workerDirectoryPageCount])
    const timeSheetRows = useMemo(() => timeSheets.map(row => ({
        ...row,
        client: clientNameById.get(row.chosenClient) || '',
        site: siteNameById.get(row.chosenSite) || '',
        // Unmatched ids stay blank rather than leaking a raw document id, and a
        // non-array value yields '' instead of reading a different field, so this
        // renders exactly what getDropdownLabel(chosenWorkers, ..., true) did.
        worker: Array.isArray(row.chosenWorkers)
            ? row.chosenWorkers.map(workerId => workerNameById.get(workerId) || '').join(', ')
            : '',
    })), [timeSheets, clientNameById, siteNameById, workerNameById])

    const pendingTimeSheets = useMemo(() => {
        const pending = timeSheetRows.filter(row => !row.status)
        const groups = new Map()
        const singles = []

        pending.forEach(row => {
            if (row.groupId) {
                if (!groups.has(row.groupId)) {
                    groups.set(row.groupId, [])
                }
                groups.get(row.groupId).push(row)
            } else {
                singles.push(row)
            }
        })

        const groupedRows = []
        for (const [groupId, rows] of groups.entries()) {
            const sorted = rows.slice().sort((a, b) => new Date(a.date) - new Date(b.date))
            const first = sorted[0]
            groupedRows.push({
                ...first,
                groupId,
                groupStartDate: first.groupStartDate || first.date,
                groupEndDate: first.groupEndDate || sorted[sorted.length - 1].date,
                groupDayCount: sorted.length,
                // The pending days themselves, for "All N days (first – last)".
                pendingFirstDate: first.date,
                pendingLastDate: sorted[sorted.length - 1].date,
                isGroupRow: true,
            })
        }

        return [...groupedRows, ...singles]
    }, [timeSheetRows])

    const timeSheetPendingSort = useTableSort(pendingTimeSheets, { key: 'date', direction: 'ascending' });
    const acceptedMonthTimeSheets = useMemo(
        () => timeSheetRows.filter(row => isSameMonth(new Date(row.date), acceptedStatsDate)),
        [timeSheetRows, acceptedStatsDate]
    )
    const timeSheetSort = useTableSort(acceptedMonthTimeSheets, { key: 'date', direction: 'descending' });
    const upcomingWorkerAllocationRows = timeSheetRows.filter(row => {
        if (row.status !== 'Accepted') return false
        const allocationDate = new Date(row.date)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        return allocationDate >= today
    }).sort((first, second) => new Date(first.date) - new Date(second.date))
    const pendingWorkerAllocationRows = timeSheetPendingSort.sortedData
        .sort((first, second) => new Date(first.date) - new Date(second.date))
    const upcomingRowsForDisplay = upcomingWorkerAllocationRows
        .sort((first, second) => new Date(first.date) - new Date(second.date))
    const completedTimeSheets = useMemo(
        () => timeSheetSort.sortedData.filter(r => r.status === 'Completed'),
        [timeSheetSort.sortedData]
    )
    const allCompletedSelected = completedTimeSheets.length > 0 && completedTimeSheets.every(timeSheet => selectedTimeSheetIds.includes(timeSheet.id))
    const handleSelectAllCompleted = () => {
        if (allCompletedSelected) {
            setSelectedTimeSheetIds([])
            return
        }
        setSelectedTimeSheetIds(completedTimeSheets.map(timeSheet => timeSheet.id))
    }
    const toggleTimeSheetSelection = (timeSheetId) => {
        setSelectedTimeSheetIds(prev => (
            prev.includes(timeSheetId) ? prev.filter(id => id !== timeSheetId) : [...prev, timeSheetId]
        ))
    }
    const handleDownloadSelectedTimeSheets = () => {
        const selected = completedTimeSheets.filter(timeSheet => selectedTimeSheetIds.includes(timeSheet.id))
        if (selected.length === 0) {
            toast.error('No timesheets selected.')
            return
        }
        startTimeSheetDownloadQueue(selected)
    }
    const invoiceRows = useMemo(
        () => invoices.map(row => ({ ...row, clientName: row.client?.name, siteName: row.site?.name, workerName: row.worker?.name })),
        [invoices]
    )
    const invoicesSort = useTableSort(invoiceRows, { key: 'date', direction: 'ascending' });
    const workerLeavesSort = useTableSort(filteredLeaves, { key: 'startDate', direction: 'ascending' });
    const workerHistoryPageSize = 5
    const workerHistoryPageCount = Math.max(1, Math.ceil(workerHistoryRows.length / workerHistoryPageSize))
    const paginatedWorkerHistoryRows = useMemo(() => {
        const firstRow = (workerHistoryPage - 1) * workerHistoryPageSize
        return workerHistoryRows.slice(firstRow, firstRow + workerHistoryPageSize)
    }, [workerHistoryRows, workerHistoryPage])
    const workerAuditPageSize = 5
    const workerAuditPageCount = Math.max(1, Math.ceil(workerAuditLogs.length / workerAuditPageSize))
    const paginatedWorkerAuditLogs = useMemo(() => {
        const firstRow = (workerAuditPage - 1) * workerAuditPageSize
        return workerAuditLogs.slice(firstRow, firstRow + workerAuditPageSize)
    }, [workerAuditLogs, workerAuditPage])

    useEffect(() => {
        setWorkerHistoryPage(1)
        setWorkerAuditPage(1)
    }, [viewingWorker?.id])

    useEffect(() => {
        setWorkerHistoryPage(currentPage => Math.min(currentPage, workerHistoryPageCount))
    }, [workerHistoryPageCount])

    useEffect(() => {
        setWorkerAuditPage(currentPage => Math.min(currentPage, workerAuditPageCount))
    }, [workerAuditPageCount])

    const [phoneViewport, setPhoneViewport] = useState(() => window.matchMedia?.('(max-width: 700px)').matches || false)
    useEffect(() => {
        const media = window.matchMedia?.('(max-width: 700px)')
        if (!media) return
        const update = () => setPhoneViewport(media.matches)
        media.addEventListener('change', update)
        return () => media.removeEventListener('change', update)
    }, [])
    const isWorker = activeOrg && activeOrg.role === 'worker' && userInfo
    const isAdmin = activeOrg && activeOrg.role === 'admin' && userInfo
    const workerLeaveRowsForDisplay = workerLeavesSort.sortedData
    useEffect(() => {
        const navigationState = location.state || {}
        const action = navigationState.workerAllocationAction
        const allocationId = navigationState.workerAllocationId
        if (!showingWorkerAllocations || !action || !allocationId) return
        const actionKey = `${action}-${allocationId}`
        if (workerAllocationActionRef.current === actionKey) return

        const allocation = timeSheetRows.find(row => row.id === allocationId)
        if (!allocation) return
        workerAllocationActionRef.current = actionKey

        if (action === 'view') {
            openTimeSheet(allocationId)
            return
        }
        if (action === 'accept') {
            setConfirmMessage({
                title: 'Accept Allocation',
                message: 'Are you sure you want to accept this allocation?',
                confirmLabel: 'Accept',
                action: () => handleRespondAllocation(allocation, 'Accept'),
            })
            return
        }
        if (action === 'reject') {
            confirmRejectAllocation(allocation)
        }
    }, [location.state, showingWorkerAllocations, timeSheetRows])
    useEffect(() => {
        const requestedTab = location.state?.workerAllocationTab
        if (!showingWorkerAllocations || !['pending', 'accepted'].includes(requestedTab)) return

        const targetKey = `${requestedTab}-${location.key}`
        if (workerAllocationTabRef.current === targetKey) return

        const targetSelector = requestedTab === 'pending'
            ? '.workerPendingAllocationCard'
            : '.workerAcceptedAllocationCard'
        const frameId = window.requestAnimationFrame(() => {
            const target = document.querySelector(targetSelector)
            if (!target) return
            workerAllocationTabRef.current = targetKey
            target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })

        return () => window.cancelAnimationFrame(frameId)
    }, [location.key, location.state, showingWorkerAllocations, pendingWorkerAllocationRows.length, upcomingRowsForDisplay.length])
    const isNewWorker = editing && viewingWorker && !viewingWorker.id
    const leaveColumnCount = isAdmin ? 5 : 4
    useEffect(() => {
        if (!isAdmin || !viewingWorker?.id) {
            setWorkerAuditLogs([])
            setWorkerAuditLoading(false)
            setWorkerHistoryRows([])
            setWorkerHistoryComments({})
            setEditingWorkerHistoryId('')
            return
        }
        fetchWorkerAuditLogs(viewingWorker.id)
        fetchWorkerHistory(viewingWorker.id)
    }, [isAdmin, viewingWorker?.id, activeOrg?.id])

    useEffect(() => {
        setWorkerHistoryComments(prev => {
            const nextComments = {}
            workerHistoryRows.forEach(row => {
                nextComments[row.id] = row.adminHistoryComment || ''
            })

            const prevKeys = Object.keys(prev)
            const nextKeys = Object.keys(nextComments)
            if (prevKeys.length === nextKeys.length && nextKeys.every(key => prev[key] === nextComments[key])) {
                return prev
            }

            return nextComments
        })
    }, [workerHistoryRows])

    useEffect(() => {
        if (!viewTimeSheet) return
        setWorkerTimesheetSections({
            shiftDetails: true,
            mapMarker: true,
            workers: true,
            documents: true,
            timeEntry: true,
            otherWorkers: true,
            supervisorSignOff: true,
        })
    }, [viewTimeSheet?.id])

    const setWorkerTimesheetSectionOpen = (sectionKey, nextValue) => {
        setWorkerTimesheetSections(prev => ({
            ...prev,
            [sectionKey]: nextValue,
        }))
    }


    const timesheetNavigationCoordinates = isWorker ? getAllocationNavigationCoordinates(viewTimeSheet) : viewTimeSheet?.siteCoordinates
    const allocationTab = isWorker && ['pending', 'accepted'].includes(searchParams.get('allocationTab')) ? searchParams.get('allocationTab') : ''
    const mobileWorkerTimesheet = !!isWorker && phoneViewport
    const isTrafficController = workerType.includes('Traffic Controller')
    const whiteCardVerificationMeta = getLicenceVerificationMeta(viewingWorker?.whiteCardVerification)
    const trafficControlVerificationMeta = getLicenceVerificationMeta(viewingWorker?.trafficControlVerification)
    const highRiskVerificationMeta = getLicenceVerificationMeta(viewingWorker?.highRiskVerification)

    const hasNotFilledBasicInfo = !bankName || !accountName || !bsb || !accountNumber || !emergencyFirstName || !emergencyLastName || !emergencyContactNo || !preExistingInjuriesYN || !prescribedMedicationYN || !medicalConditionsYN || !allergiesYN || !whiteCardLicenseNo || (isWhiteCardCert && !certificateNumberSuffix(whiteCardLicenseNo).trim()) || !whiteCardPicture || !whiteCardStartDate
    const hasNotFilledTrafficInfo = workerType.length > 0 && isTrafficController && (!trafficControlLicenseNo || (isTrafficCert && !certificateNumberSuffix(trafficControlLicenseNo, 'SOC').trim()) || !trafficControlClass || trafficControlClass.length === 0 || !trafficControlPicture || !trafficControlStartDate)

    const getWorkerNameForTimesheet = (timeSheet) => {
        const userName = formatName([userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(' ').trim())
        const workerRole = String(timeSheet?.workerCapacity || '').trim()
        if (userName) return workerRole ? `${userName} (${workerRole})` : userName
        const fallbackName = timeSheet?.workerName || timeSheet?.worker?.name || timeSheet?.chosenWorkerNames?.[0]?.name || '-'
        const fallbackRole = timeSheet?.chosenWorkerNames?.[0]?.role || workerRole
        return fallbackRole ? `${fallbackName} (${fallbackRole})` : fallbackName
    }

    const formatWorkerDisplayName = (worker) => {
        const name = String(worker?.name || '').trim()
        const role = String(worker?.role || '').trim()
        return role ? `${name} (${role})` : name
    }

    const renderPhoneLinkInText = (value) => {
        const text = String(value || '').trim()
        if (!text) return '-'
        const match = text.match(phonePattern)
        if (!match) return text

        const phoneText = match[0]
        const phoneHref = removeWhitespace(phoneText)
        const index = match.index || 0
        const before = text.slice(0, index)
        const after = text.slice(index + phoneText.length)

        return <>
            {before}
            <a href={`tel:${phoneHref}`}>{phoneText}</a>
            {after}
        </>
    }

    const renderWorkerLicences = () => (<>
                                        <Section title={'Driver Licence'} className='width-100 workerProfileCard' variant='card'>
                                            <div className='workerProfileFieldGrid workerProfileFieldGridTwo'>
                                                <Input disabled={!editing} value={driverLicence.number} setValue={value => changeDriverLicence('number', value)} label='Driver Licence Number' placeholder='Licence number' />
                                                <Dropdown disabled={!editing} label='State / Territory' options={['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].map(value => ({ label: value, value }))} value={driverLicence.state ? { label: driverLicence.state, value: driverLicence.state } : null} setValue={option => changeDriverLicence('state', option?.value || '')} />
                                                <Input disabled={!editing} value={driverLicence.class} setValue={value => changeDriverLicence('class', value)} label='Driver Licence Class' placeholder='e.g. C, LR, MR, HR' />
                                                <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={driverLicence.expiryDate} setStartDate={value => changeDriverLicence('expiryDate', value)} label='Driver Licence Expiry Date' />
                                                <div className='workerProfileDocumentField'>
                                                    <MyDropzone confidential key={`driver-licence-${viewingWorker?.id || 'new'}`} setUploading={setUploading} disabled={!editing} storageLocation={`WorkerCertifications/${randomString()}`} label='Driver Licence Upload' customMessage='Click or drag a licence image or PDF here to upload' editing={true} errors={[]} allowPdf name='document' image={driverLicence.picture} updateImage={guardWorkerUpload(value => changeDriverLicence('picture', value))} ownerWorkerId={viewingWorker?.id || ''} />
                                                </div>
                                            </div>
                                        </Section>
                                        <Section title={'Licences / Qualifications'} className='width-100 workerProfileCard' variant='card'>
                                            <div className='workerProfileNestedStack workerProfileLicenceStack'>

                                                <Section title={'White Card'} className='width-100 workerProfileNestedCard workerProfileLicenceCard' variant='card' action={whiteCardPicture?.url && isAdmin ? <Button variant="secondary" size="md" type='button' className='workerLicenceHeaderDownload' onClick={() => openConfidentialFile(whiteCardPicture, 'White card', true)}><DownloadIcon />Download</Button> : null}>
                                                    <div className='workerProfileFieldGrid workerProfileFieldGridTwo workerProfileLicenceFieldGrid workerWhiteCardLayout'>
                                                        <div className='workerWhiteCardDetails'>
                                                            <div className='workerDocumentTypeChoices' role='group' aria-label='Document type'>
                                                                {[{ label: 'Certificate', certificate: true }, { label: 'White Card', certificate: false }].map(option => (
                                                                    <FieldLabel choice key={option.label}>
                                                                        <UiCheckbox disabled={!editing} checked={isWhiteCardCert === option.certificate} onChange={() => {
                                                                            if (isWhiteCardCert === option.certificate) return
                                                                            setWhiteCardLicenseNo(option.certificate ? 'SOT' : '')
                                                                            setWhiteCardStartDate('')
                                                                            setWhiteCardPicture('')
                                                                        }} />
                                                                        {option.label}
                                                                    </FieldLabel>
                                                                ))}
                                                            </div>
                                                            {isWhiteCardCert ? <div className='workerCertificateNumber'>
                                                                <FieldLabel className='fieldLabel' htmlFor='worker-certificate-number'>Certificate No</FieldLabel>
                                                                <div className='workerCertificateNumberRow'>
                                                                    <span className='workerCertificatePrefix'>SOT</span>
                                                                    <UiInput id='worker-certificate-number' disabled={!editing} value={certificateNumberSuffix(whiteCardLicenseNo)} onChange={event => setWhiteCardLicenseNo(toCertificateNumber(event.target.value))} inputMode='numeric' />
                                                                </div>
                                                            </div> : <Input disabled={!editing} value={whiteCardLicenseNo} setValue={setWhiteCardLicenseNo} placeholder='White Card Number' label='White Card Number' />}
                                                            <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={whiteCardStartDate} setStartDate={setWhiteCardStartDate} label={isWhiteCardCert ? 'Certificate Date' : 'Date of Issue'} />
                                                            {isWhiteCardCert && <MyCalendar disabled showDateOnly startDate={certificateExpiryDate(whiteCardStartDate)} setStartDate={() => {}} label='Expiry Date' />}
                                                            {!isWhiteCardCert && isAdmin && !!viewingWorker?.id && (
                                                                <div className='workerProfileVerificationActions'>
                                                                    <span className={whiteCardVerificationMeta.className}>{whiteCardVerificationMeta.label}</span>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationRecheck'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || recheckingVerificationType === 'white_card'}
                                                                        onClick={() => handleRecheckVerification('white_card')}
                                                                    >
                                                                        <ResetIcon />{recheckingVerificationType === 'white_card' ? 'Rechecking...' : 'Recheck'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationApprove'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'white_card:verified'}
                                                                        onClick={() => handleManualVerification('white_card', 'verified')}
                                                                    >
                                                                        <CheckIcon />{manualVerificationAction === 'white_card:verified' ? 'Saving...' : 'Manual Verify'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationReject'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'white_card:invalid'}
                                                                        onClick={() => handleManualVerification('white_card', 'invalid')}
                                                                    >
                                                                        <XIcon />{manualVerificationAction === 'white_card:invalid' ? 'Saving...' : 'Mark Unverified'}
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='workerProfileDocumentField workerWhiteCardImage'>
                                                            <MyDropzone confidential key={`white-card-${viewingWorker?.id || 'new'}-${whiteCardPicture ? 'set' : 'empty'}`} setUploading={setUploading} disabled={!editing} storageLocation={`WorkerCertifications/${randomString()}`} label={isWhiteCardCert ? 'Upload photo of certificate' : 'Upload photo of white card'} customMessage={isWhiteCardCert ? 'Click or drag a certificate photo here to upload' : 'Click or drag a white card photo here to upload'} editing={true} errors={[]} allowPdf name={'document'} image={whiteCardPicture} updateImage={guardWorkerUpload(setWhiteCardPicture)} ownerWorkerId={viewingWorker?.id || ''} />
                                                        </div>
                                                    </div>
                                                </Section>
                                                <Section title={'Traffic Management'} className='width-100 workerProfileNestedCard workerProfileLicenceCard' variant='card' action={trafficControlPicture?.url && isAdmin ? <Button variant="secondary" size="md" type='button' className='workerLicenceHeaderDownload' onClick={() => openConfidentialFile(trafficControlPicture, 'Traffic control', true)}><DownloadIcon />Download</Button> : null}>
                                                    <div className='workerProfileFieldGrid workerProfileFieldGridTwo workerProfileLicenceFieldGrid workerTrafficManagementLayout'>
                                                        <div className='workerTrafficManagementDetails'>
                                                            <div className='workerDocumentTypeChoices' role='group' aria-label='Traffic Management document type'>
                                                                {[{ label: 'Certificate', certificate: true }, { label: 'Traffic Control Card', certificate: false }].map(option => (
                                                                    <FieldLabel choice key={option.label}>
                                                                        <UiCheckbox disabled={!editing} checked={isTrafficCert === option.certificate} onChange={() => {
                                                                            if (isTrafficCert === option.certificate) return
                                                                            setTrafficControlLicenseNo(option.certificate ? 'SOC' : '')
                                                                            if (option.certificate) setTrafficControlClass(previous => previous.length > 1 ? [] : previous)
                                                                            setTrafficControlStartDate('')
                                                                            setTrafficControlPicture('')
                                                                        }} />{option.label}
                                                                    </FieldLabel>
                                                                ))}
                                                            </div>
                                                            {isTrafficCert ? <div className='workerCertificateNumber'>
                                                                <FieldLabel className='fieldLabel' htmlFor='worker-traffic-certificate-number'>Certificate No</FieldLabel>
                                                                <div className='workerCertificateNumberRow'>
                                                                    <span className='workerCertificatePrefix'>SOC</span>
                                                                    <UiInput id='worker-traffic-certificate-number' disabled={!editing} value={certificateNumberSuffix(trafficControlLicenseNo, 'SOC')} onChange={event => setTrafficControlLicenseNo(toCertificateNumber(event.target.value, 'SOC'))} inputMode='numeric' />
                                                                </div>
                                                            </div> : <Input disabled={!editing} value={trafficControlLicenseNo} setValue={setTrafficControlLicenseNo} placeholder='Traffic Control Card Number' label='Traffic Control Card Number' required={isWorker && isTrafficController} />}
                                                            <div>
                                                                <FieldLabel className='fieldLabel' required={isWorker && isTrafficController}>Class</FieldLabel>
                                                                <div className='workerDocumentTypeChoices' role='group' aria-label='Traffic Management class'>
                                                                    {TrafficClassOptions.map(option => <FieldLabel choice key={option}>
                                                                        <UiCheckbox disabled={!editing || (isTrafficCert && trafficControlCertificates.some(item => item.class === option))} checked={trafficControlClass.includes(option)} onChange={event => setTrafficControlClass(previous => event.target.checked ? (isTrafficCert ? [option] : [...new Set([...previous, option])]) : previous.filter(value => value !== option))} />{option}
                                                                    </FieldLabel>)}
                                                                </div>
                                                            </div>
                                                            <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={trafficControlStartDate} setStartDate={setTrafficControlStartDate} label={isTrafficCert ? 'Certificate Date' : 'Date of Issue'} required={isWorker && isTrafficController} />
                                                            {isTrafficCert && <MyCalendar disabled showDateOnly startDate={certificateExpiryDate(trafficControlStartDate, 90)} setStartDate={() => {}} label='Expiry Date' />}
                                                            {!isTrafficCert && isAdmin && !!viewingWorker?.id && (
                                                                <div className='workerProfileVerificationActions'>
                                                                    <span className={trafficControlVerificationMeta.className}>{trafficControlVerificationMeta.label}</span>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationRecheck'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || recheckingVerificationType === 'traffic_control'}
                                                                        onClick={() => handleRecheckVerification('traffic_control')}
                                                                    >
                                                                        <ResetIcon />{recheckingVerificationType === 'traffic_control' ? 'Rechecking...' : 'Recheck'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationApprove'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'traffic_control:verified'}
                                                                        onClick={() => handleManualVerification('traffic_control', 'verified')}
                                                                    >
                                                                        <CheckIcon />{manualVerificationAction === 'traffic_control:verified' ? 'Saving...' : 'Manual Verify'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationReject'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'traffic_control:invalid'}
                                                                        onClick={() => handleManualVerification('traffic_control', 'invalid')}
                                                                    >
                                                                        <XIcon />{manualVerificationAction === 'traffic_control:invalid' ? 'Saving...' : 'Mark Unverified'}
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='workerProfileDocumentField workerTrafficManagementImage'>
                                                            <MyDropzone confidential key={`traffic-control-${viewingWorker?.id || 'new'}-${trafficControlPicture ? 'set' : 'empty'}`} setUploading={setUploading} disabled={!editing} storageLocation={`WorkerCertifications/${randomString()}`} label={isTrafficCert ? 'Upload photo of certificate' : 'Upload photo of traffic control card'} customMessage={isTrafficCert ? 'Click or drag a certificate photo here to upload' : 'Click or drag a traffic control card photo here to upload'} editing={true} errors={[]} required={isWorker && isTrafficController} allowPdf name={'document'} image={trafficControlPicture} updateImage={guardWorkerUpload(setTrafficControlPicture)} ownerWorkerId={viewingWorker?.id || ''} />
                                                        </div>
                                                    </div>
                                                    {isTrafficCert && <AdditionalTrafficCertificates certificates={trafficControlCertificates} primaryClasses={trafficControlClass} setCertificates={setTrafficControlCertificates} editing={editing} workerId={viewingWorker?.id} setUploading={setUploading} guardUpload={guardWorkerUpload} />}
                                                </Section>
                                                <Section title={'High Risk Work License'} className='width-100 workerProfileNestedCard workerProfileLicenceCard' variant='card' action={highRiskPicture?.url && isAdmin ? <Button variant="secondary" size="md" type='button' className='workerLicenceHeaderDownload' onClick={() => openConfidentialFile(highRiskPicture, 'High risk work licence', true)}><DownloadIcon />Download</Button> : null}>
                                                    <div className='workerProfileFieldGrid workerProfileFieldGridTwo workerProfileLicenceFieldGrid workerHighRiskLayout'>
                                                        <div className='workerHighRiskDetails'>
                                                            <Input disabled={!editing} value={highRiskLicenseNo} setValue={setHighRiskLicenseNo} placeholder={'License No'} label={'License No'} />
                                                            <Dropdown isMulti label={'Class'} disabled={!editing} options={HighRiskClassOptions.map(r => ({ label: r, value: r }))} value={getDropdownValue(highRiskClass, HighRiskClassOptions.map(r => ({ label: r, value: r })), true)} setValue={v => setHighRiskClass(v.map(x => x.value))} />
                                                            <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={highRiskStartDate} setStartDate={setHighRiskStartDate} label={'Date of Issue'} />
                                                            <MyCalendar disabled={!editing} showDateOnly noMaxDate minDate showYearDropdown startDate={highRiskExpiryDate} setStartDate={setHighRiskExpiryDate} label={'Date of Expiry'} />
                                                            {isAdmin && !!viewingWorker?.id && (
                                                                <div className='workerProfileVerificationActions'>
                                                                    <span className={highRiskVerificationMeta.className}>{highRiskVerificationMeta.label}</span>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationRecheck'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || recheckingVerificationType === 'high_risk_work'}
                                                                        onClick={() => handleRecheckVerification('high_risk_work')}
                                                                    >
                                                                        <ResetIcon />{recheckingVerificationType === 'high_risk_work' ? 'Rechecking...' : 'Recheck'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationApprove'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'high_risk_work:verified'}
                                                                        onClick={() => handleManualVerification('high_risk_work', 'verified')}
                                                                    >
                                                                        <CheckIcon />{manualVerificationAction === 'high_risk_work:verified' ? 'Saving...' : 'Manual Verify'}
                                                                    </Button>
                                                                    <Button variant="secondary" size="md"
                                                                        type="button"
                                                                        className='workerVerificationAction workerVerificationReject'
                                                                        title={editing ? 'Save or cancel your changes first' : undefined}
                                                                        disabled={editing || manualVerificationAction === 'high_risk_work:invalid'}
                                                                        onClick={() => handleManualVerification('high_risk_work', 'invalid')}
                                                                    >
                                                                        <XIcon />{manualVerificationAction === 'high_risk_work:invalid' ? 'Saving...' : 'Mark Unverified'}
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='workerProfileDocumentField workerHighRiskImage'>
                                                            <MyDropzone confidential key={`high-risk-${viewingWorker?.id || 'new'}-${highRiskPicture ? 'set' : 'empty'}`} setUploading={setUploading} disabled={!editing} storageLocation={`WorkerCertifications/${randomString()}`} label={'Add Image'} customMessage={'Click here/Drop files here to upload (Must have a clear white background)'} editing={true} errors={[]} allowPdf name={'document'} image={highRiskPicture} updateImage={guardWorkerUpload(setHighRiskPicture)} ownerWorkerId={viewingWorker?.id || ''} />
                                                        </div>
                                                    </div>
                                                </Section>
                                                {/* <Section title={'Contractor License'} className='width-50'>
                                            <Input disabled={!editing} value={contractorLicenseNo} setValue={setContractorLicenseNo} placeholder={'License No'} label={'License No'} />
                                            <Dropdown isMulti label={'Class'} disabled={!editing} required options={ContractorClassOptions.map(r => ({ label: r, value: r }))} value={getDropdownValue(contractorClass, ContractorClassOptions.map(r => ({ label: r, value: r })), true)} setValue={v => setContractorClass(v.map(x => x.value))} />
                                            <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={contractorStartDate} setStartDate={setContractorStartDate} label={'Effective Date'} />
                                            <MyCalendar disabled={!editing} showDateOnly noMaxDate minDate showYearDropdown startDate={contractorExpiryDate} setStartDate={setContractorExpiryDate} label={'Expiry'} />
                                            <MyDropzone confidential key={`contractor-${viewingWorker?.id || 'new'}-${contractorPicture ? 'set' : 'empty'}`} setUploading={setUploading} disabled={!editing} storageLocation={`WorkerCertifications/${randomString()}`} label={'Add Image'} customMessage={'Click here/Drop files here to upload (Must have a clear white background)'} editing={true} errors={[]} allowPdf name={'document'} image={contractorPicture} updateImage={guardWorkerUpload(setContractorPicture)} />
                                        </Section> */}
                                            </div>
                                        </Section>
    </>)

    return (<div>
        <Header />
        <div className='pageShell'>
            <Sidebar />
            <PageContent as="div" className={isWorker && !showingWorkerAllocations && !viewingWorker && !viewTimeSheet
                ? 'pageContent pageContentPadded workerPageContent workerProfileTwoColumnPage workerPortalPage'
                : `pageContent pageContentPadded workerPageContent${isWorker ? ' workerPortalPage' : ''}`}>
                <PageHeader title={showingWorkerAllocations ? 'Allocations' : isWorker ? 'My Profile' : 'Workers'} subtitle={<>{showingWorkerAllocations ? (allocationTab === 'pending' ? 'Allocations awaiting your response' : allocationTab === 'accepted' ? 'Your accepted allocations' : 'Pending and accepted allocations') : 'Manage your workforce and signups'}</>} />
                <CompactSuccessModal success={successMessage} setSuccess={setSuccessMessage} />
                {downloadTimeSheet && <TimesheetPdfGenerator
                    timesheet={downloadTimeSheet}
                    workerName={getWorkerNameForTimesheet(downloadTimeSheet)}
                    logo={activeOrgInfo?.logo?.url}
                    onComplete={advanceTimeSheetDownloadQueue}
                />}
                <ModalComponent
                    showModal={!!confirmMessage}
                    setShowModal={setConfirmMessage}
                    customOverlayStyle={{ zIndex: 1400 }}
                    customMaxWidth={confirmMessage?.title === 'Accept Allocation' ? '320px' : undefined}
                    customContentStyle={confirmMessage?.title === 'Accept Allocation' ? { width: 'min(320px, calc(100vw - 32px))', minWidth: 0, padding: '16px' } : undefined}
                >
                    <h2 className='modalTitle'>{confirmMessage?.title || 'Confirm'}</h2>
                    <p className='modalSubtitle'>{confirmMessage?.message}</p>
                    {confirmMessage?.rejectChoices && <div className='rejectScopeChoices' role='radiogroup' aria-label='Which days to reject'>
                        {confirmMessage.rejectChoices.map(choice => <FieldLabel choice key={choice.value} className={'rejectScopeChoice' + (confirmMessage.rejectScope === choice.value ? ' rejectScopeChoiceSelected' : '')}>
                            <UiCheckbox type='radio' name='reject-scope' value={choice.value} checked={confirmMessage.rejectScope === choice.value} disabled={loading} onChange={() => setConfirmMessage(current => ({ ...current, rejectScope: choice.value }))} />
                            <span>{choice.label}</span>
                        </FieldLabel>)}
                    </div>}

                    <div className='modalFooter'>
                        <Button variant="secondary" size="md" className='secondaryButton' disabled={loading} onClick={() => setConfirmMessage()}>{confirmMessage?.cancelLabel || 'Cancel'}</Button>
                        <Button variant={confirmMessage?.title === 'Accept Allocation' ? 'secondary' : 'danger'} size="md" className={confirmMessage?.title === 'Accept Allocation' ? 'workerAcceptConfirmButton' : 'modalDangerButton'} disabled={loading || (!!confirmMessage?.rejectChoices && !confirmMessage?.rejectScope)} onClick={() => confirmMessage.action(confirmMessage.rejectScope)}>{confirmMessage?.confirmLabel || 'Yes'}</Button>
                    </div>
                </ModalComponent>

                {
                    viewTimeSheet ? <>
                        <div className={`workerHistoryTimesheetModal${mobileWorkerTimesheet ? ' workerAllocationTimesheetMobile' : ''}`}>
                        <div className='workerHistoryTimesheetModalHeader'>
                            <div>
                                <h3 className='pageTitle'>Timesheet Details</h3>
                                <p className='pageSubtitle'>{viewTimeSheet.allocationNumber || viewTimeSheet.allocationId || (mobileWorkerTimesheet ? 'Complete your shift hours' : 'Worker history entry')}</p>
                            </div>
                            <Button variant="secondary" size="md" type='button' className='secondaryButton' onClick={() => setViewTimeSheet(false)}>Cancel</Button>
                        </div>
                        <Section
                            title={mobileWorkerTimesheet ? 'Site' : 'Shift Details'}
                            className='width-100'
                            variant='card'
                            collapsible={!mobileWorkerTimesheet}
                            expanded={workerTimesheetSections.shiftDetails}
                            onToggle={(nextValue) => setWorkerTimesheetSectionOpen('shiftDetails', nextValue)}
                        >
                            <div className='detailGrid'>
                                {mobileWorkerTimesheet && <div className='detailItem'><span className='detailLabel'>Allocation ID</span><span className='detailValue'>{viewTimeSheet.allocationNumber || viewTimeSheet.allocationId || '-'}</span></div>}
                                <div className='detailItem'><span className='detailLabel'>Client Name</span><span className='detailValue'>{viewTimeSheet.clientName || '-'}</span></div>
                                <div className='detailItem'><span className='detailLabel'>Site Name</span><span className='detailValue'>{viewTimeSheet.siteName || '-'}</span></div>
                                <div className='detailItem'><span className='detailLabel'>Allocation Date/Time</span><span className='detailValue'>{format(new Date(viewTimeSheet.date), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(viewTimeSheet.date))}</span></div>
                                <div className='detailItem detailItemWide'>
                                    <span className='detailLabel'>Location Address</span>
                                    <span className='detailValue'>
                                        {getAllocationDisplayAddress(viewTimeSheet)} {hasValidMapCoordinates(timesheetNavigationCoordinates) && <a href={`https://www.google.com/maps?q=${timesheetNavigationCoordinates[0]},${timesheetNavigationCoordinates[1]}`} target='_blank' rel='noreferrer'>Open in Google Maps</a>}
                                    </span>
                                </div>
                                <div className='detailItem detailItemWide'><span className='detailLabel'>Site Manager Details</span><span className='detailValue'>{renderPhoneLinkInText(viewTimeSheet.siteManagerDetails) || '-'}</span></div>
                                {!mobileWorkerTimesheet && <div className='detailItem detailItemWide'><span className='detailLabel'>Scope of Works</span><span className='detailValue'>{viewTimeSheet.scopeOfWorks || '-'}</span></div>}
                                <div className='detailItem detailItemWide'><span className='detailLabel'>Comments</span><span className='detailValue'>{viewTimeSheet.comments || '-'}</span></div>
                                {!!viewTimeSheet.signsDroppedToSite && (
                                    <div className='detailItem detailItemWide'><span className='detailLabel'>Notes</span><span className='detailValue'>Equipment dropped to site.</span></div>
                                )}
                            </div>
                        </Section>

                        {viewTimeSheet.dropMapMarker && hasValidMapCoordinates(viewTimeSheet.mapMarkerCoordinates) && (
                            <Section
                                title={'Map Marker'}
                                className='width-100'
                                variant='card'
                                collapsible={!mobileWorkerTimesheet}
                                expanded={workerTimesheetSections.mapMarker}
                                onToggle={(nextValue) => setWorkerTimesheetSectionOpen('mapMarker', nextValue)}
                            >
                                <div className='detailGrid' style={{ marginBottom: '16px' }}>
                                    <div className='detailItem'><span className='detailLabel'>{isWorker ? 'Marker Address' : 'Marker'}</span><span className='detailValue'>{isWorker ? getAllocationDisplayAddress(viewTimeSheet) : viewTimeSheet.mapMarkerName || '-'}</span></div>
                                    <div className='detailItem'><span className='detailLabel'>Coordinates</span><span className='detailValue'>{Number(viewTimeSheet.mapMarkerCoordinates[0]).toFixed(6)}, {Number(viewTimeSheet.mapMarkerCoordinates[1]).toFixed(6)}</span></div>
                                    {viewTimeSheet.mapMarkerLink && (
                                        <div className='detailItem'><span className='detailLabel'>Link</span><span className='detailValue'><a href={viewTimeSheet.mapMarkerLink} target='_blank' rel='noreferrer'>Open Marker in Google Maps</a></span></div>
                                    )}
                                </div>
                                <AllocationMarkerMap
                                    center={{ lat: Number(viewTimeSheet.mapMarkerCoordinates[0]), lng: Number(viewTimeSheet.mapMarkerCoordinates[1]) }}
                                    markerCoordinates={viewTimeSheet.mapMarkerCoordinates}
                                    height='260px'
                                />
                            </Section>
                        )}

                        <Section
                            title={'Workers'}
                            className='width-100'
                            variant='card'
                            collapsible={!mobileWorkerTimesheet}
                            expanded={workerTimesheetSections.workers}
                            onToggle={(nextValue) => setWorkerTimesheetSectionOpen('workers', nextValue)}
                        >
                            <div className='modalList'>
                                {(viewTimeSheet.chosenWorkerNames || []).map((worker, workerIndex) => (
                                    <div key={`ts-worker-${workerIndex}`} className='modalListRow'>
                                        <div className='modalListName'>
                                            {formatWorkerDisplayName(worker)}
                                            {worker.assetName && <span className='detailValue' style={{ display: 'block', color: '#64748b', fontWeight: 400 }}>Assets: {worker.assetName}</span>}
                                        </div>
                                        <div>
                                            {worker.contactNo ? <a href={`tel:${worker.contactNo}`}>{formatPhone(worker.contactNo)}</a> : <span className='modalEmpty'>No phone number</span>}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Section>

                        <Section
                            title={mobileWorkerTimesheet ? 'Task' : 'Documents'}
                            className='width-100'
                            variant='card'
                            collapsible={!mobileWorkerTimesheet}
                            expanded={workerTimesheetSections.documents}
                            onToggle={(nextValue) => setWorkerTimesheetSectionOpen('documents', nextValue)}
                        >
                            {mobileWorkerTimesheet && <div className='detailItem'><span className='detailLabel'>Scope of Works</span><span className='detailValue'>{viewTimeSheet.scopeOfWorks || '-'}</span></div>}
                            <div className='workerTimesheetDocuments'>
                                {(Array.isArray(viewTimeSheet.document) ? viewTimeSheet.document : viewTimeSheet.document ? [viewTimeSheet.document] : []).length > 0 ? (
                                    <div className='workerTimesheetDocumentList'>
                                        {(Array.isArray(viewTimeSheet.document) ? viewTimeSheet.document : [viewTimeSheet.document]).map((doc, index) => {
                                            const filePath = doc?.url || doc?.filePath || doc?.storagePath || doc?.path || doc?.fullPath || ''
                                            if (!doc || !filePath) return null
                                            const isPdf = doc.pdf || normalizeSearch(filePath).includes('.pdf')
                                            return (
                                                <div key={`timesheet-doc-${index}`} className='workerTimesheetDocumentCard'>
                                                    <div className='detailLabel' style={{ marginBottom: '8px' }}>{doc.name || doc.note || `Document ${index + 1}`}</div>
                                                    {isPdf ? (
                                                        <div>
                                                            <Button variant="secondary" size="md" type='button' className='allocationDetailDocumentViewButton' onClick={() => openConfidentialFile(doc, doc.name || `Document ${index + 1}`)}>Open Document</Button>
                                                        </div>
                                                    ) : (
                                                        <div style={{ width: '100%', maxWidth: '400px' }}>
                                                            <Button variant="secondary" size="md" type='button' className='allocationDetailDocumentViewButton' onClick={() => openConfidentialFile(doc, doc.name || `Document ${index + 1}`)}>Open Picture</Button>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                ) : (
                                    <div className='modalEmpty'>No documents provided.</div>
                                )}

                                {isWorker && (
                                    <div className='workerTimesheetUploadBlock'>
                                        {!showSiteImageUpload && (
                                            <Button variant="secondary" size="md" type='button' className='workerTimesheetUploadButton' onClick={() => setShowSiteImageUpload(true)}>
                                                Upload Site Image
                                            </Button>
                                        )}
                                        {showSiteImageUpload && (
                                            <div className='workerTimesheetUploadComposer'>
                                                <MyDropzoneMulti
                                                    disabled={false}
                                                    storageLocation={`SiteDocs/${randomString()}`}
                                                    label={'Site Images'}
                                                    customMessage={'Click here/Drop files here to upload'}
                                                    editing={true}
                                                    errors={[]}
                                                    name={'siteImages'}
                                                    images={sitePictures}
                                                    updateImages={(docs) => setSitePictures(Array.isArray(docs) ? docs : docs ? [docs] : [])}
                                                    allowMultiple={true}
                                                    setUploading={setSitePictureUploading}
                                                />
                                                <div className='workerTimesheetActionRow'>
                                                    <Button data-action-tone="save" variant="soft" size="md"
                                                        className='saveWithIcon'
                                                        disabled={!sitePictures || sitePictures.length === 0 || sitePictureUploading}
                                                        onClick={handleUploadSitePicture}
                                                    >
                                                        Save
                                                    </Button>
                                                    <Button data-action-tone="cancel" variant="secondary" size="md"
                                                        className='secondaryButton'
                                                        onClick={() => { setShowSiteImageUpload(false); setSitePictures([]) }}
                                                        disabled={sitePictureUploading}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {isWorker && (
                                    <div className='workerTimesheetUploadBlock'>
                                        <FieldLabel className="fieldLabel">Your Site Uploads</FieldLabel>
                                        <div className='workerTimesheetUploadGallery'>
                                            {siteWorkerUploads.map((row, index) => (
                                                <div key={`site-upload-${index}`} className='workerTimesheetUploadCard'>
                                                    {row.picture && (row.picture.pdf || normalizeSearch(row.picture.url || '').includes('.pdf')) ? (
                                                        <a href={row.picture.url} target='_blank' rel='noreferrer'>Open PDF</a>
                                                    ) : (
                                                        row.picture && <img src={row.picture.url} alt={`Site upload ${index + 1}`} style={{ width: '100%', height: '120px', objectFit: 'contain' }} />
                                                    )}
                                                    <div className='workerTimesheetUploadDate'>
                                                        {row.date ? format(new Date(row.date), 'EEE, d MMM yyyy') : ''}
                                                    </div>
                                                </div>
                                            ))}
                                            {siteWorkerUploads.length === 0 && (
                                                <div className='modalEmpty'>No uploads yet.</div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Section>

                        <Section
                            title={mobileWorkerTimesheet ? 'Shift Sign Off' : 'Time Entry'}
                            className='width-100'
                            variant='card'
                            collapsible={!mobileWorkerTimesheet}
                            expanded={workerTimesheetSections.timeEntry}
                            onToggle={(nextValue) => setWorkerTimesheetSectionOpen('timeEntry', nextValue)}
                        >
                            <div className='workerTimesheetEntryStack'>
                                {!mobileWorkerTimesheet && <div className='detailItem'>
                                    <span className='detailLabel'>Allocation Date/Time</span>
                                    <span className='detailValue'>{format(new Date(viewTimeSheet.date), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(viewTimeSheet.date))}</span>
                                </div>}
                                {mobileWorkerTimesheet ? <div className='workerShiftMobileFields'>
                                    <WorkerShiftDateTime prefix='Start' value={clockIn} onChange={setClockIn} disabled={!!viewTimeSheet.clockOut} />
                                    <WorkerShiftDateTime prefix='End' value={clockOut} onChange={setClockOut} disabled={!!viewTimeSheet.clockOut} />
                                    <div className='workerShiftDateTimeRow'>
                                        <Input disabled={!!viewTimeSheet.clockOut} type='number' inputMode='numeric' step='15' value={breakMinutes} setValue={setBreakMinutes} label='Break (minutes)' />
                                        <Input disabled type='number' label='Total Work Hours' value={clockIn && clockOut ? getQuarterHoursFromTimes({ clockIn, clockOut, breakMinutes, breakIncludedInPay, minuteOffset: 1 }) : ''} />
                                    </div>
                                </div> : <>                                <div className='workerTimesheetFieldGrid'>
                                    <MyCalendar nativeOnMobile={isWorker} noMaxDate disabled={viewTimeSheet.clockOut} startDate={clockIn} setStartDate={handleShiftStartChange} label={'Shift Start'} timeIntervals={15} />
                                    <MyCalendar nativeOnMobile={isWorker} noMaxDate disabled={viewTimeSheet.clockOut} startDate={clockOut} setStartDate={handleShiftEndChange} label={'Shift End'} timeIntervals={15} />
                                    <Input disabled={viewTimeSheet.clockOut} type={'number'} inputMode={'numeric'} value={breakMinutes} setValue={setBreakMinutes} placeholder={'0'} label={'Break (mins)'} />
                                    {clockIn && clockOut &&
                                        <Input disabled={true} type={'number'} label={'Hours'} value={getQuarterHoursFromTimes({ clockIn, clockOut, breakMinutes, breakIncludedInPay, minuteOffset: 1 })} />
                                    }
                                </div>
</>}
                            </div>
                            {mobileWorkerTimesheet && <div className='workerShiftSupervisor'>                            <div className='workerTimesheetSupervisorStack'>
                                <Checkbox disabled={viewTimeSheet.clockOut} value={supervisorNotAvailable} setValue={setSupervisorNotAvailable} label={'No one on site to sign off'} />
                                {
                                    !supervisorNotAvailable && <>
                                        <div className='workerTimesheetSupervisorField'>
                                            <Input disabled={viewTimeSheet.clockOut} value={supervisorName} setValue={setSupervisorName} placeholder={'Supervisor Name'} label={'Supervisor Name'} required />
                                        </div>
                                        <WorkerSignatureInput value={supervisorSign} onChange={setSupervisorSign} disabled={!!viewTimeSheet.clockOut} />
                                    </>
                                }
                            </div>
</div>}
                        </Section>

                        {(viewTimeSheet.othersTimeSheets || []).length > 0 && <>
                            <Section
                                title={'Other Workers'}
                                className='width-100'
                                variant='card'
                                collapsible={!mobileWorkerTimesheet}
                                expanded={workerTimesheetSections.otherWorkers}
                                onToggle={(nextValue) => setWorkerTimesheetSectionOpen('otherWorkers', nextValue)}
                            >
                                <Checkbox disabled={viewTimeSheet.clockOut} value={signOffOtherWorkers} setValue={(nextValue) => {
                                    setSignOffOtherWorkers(nextValue)
                                    if (nextValue) {
                                        setFillingFor(buildSignOffOtherWorkers())
                                    } else {
                                        // Unticking cancels the sign-off; nothing is sent for other workers.
                                        setApplySameWorkHours(false)
                                        setFillingFor([])
                                    }
                                }} label={'Sign off other workers'} />
                                {signOffOtherWorkers && <Checkbox disabled={viewTimeSheet.clockOut} value={applySameWorkHours} setValue={setApplySameWorkHours} label={'Apply my shift start, shift end and break to all selected workers'} />}
                                {signOffOtherWorkers && <h3 className='subPanelHeading'>Other Workers</h3>}
                                {signOffOtherWorkers && (
                                    <>
                                        {
                                            viewTimeSheet.othersTimeSheets.map(other => <div key={other.userId}>
                                                <Checkbox disabled={other.status === 'Completed' || viewTimeSheet.clockOut} value={fillingFor.map(x => x.id).includes(other.userId)} setValue={() => fillingFor.map(x => x.id).includes(other.userId) ? setFillingFor(fillingFor.filter(r => r.id !== other.userId)) : setFillingFor([...fillingFor, { id: other.userId, clockIn: '', clockOut: '', breakMinutes: '0', breakIncludedInPay: false }])} label={viewTimeSheet.chosenWorkerNames.find(x => x.id === other.userId)?.name} />
                                                {
                                                    fillingFor.filter(r => r.id === other.userId).map(otherUser => <div key={otherUser.id} className='workerTimesheetOtherWorkerEditor'>
                                                        <div className='workerTimesheetFieldGrid'>
                                                            <MyCalendar nativeOnMobile={isWorker} noMaxDate disabled={applySameWorkHours || other.status === 'Completed' || viewTimeSheet.clockOut} startDate={otherUser.clockIn} setStartDate={v => { setFillingFor(fillingFor.map(r => r.id === otherUser.id ? { ...r, clockIn: v } : r)) }} label={`Shift Start`} timeIntervals={15} />
                                                            <MyCalendar nativeOnMobile={isWorker} noMaxDate disabled={applySameWorkHours || other.status === 'Completed' || viewTimeSheet.clockOut} startDate={otherUser.clockOut} setStartDate={v => { setFillingFor(fillingFor.map(r => r.id === otherUser.id ? { ...r, clockOut: v } : r)) }} label={`Shift End`} timeIntervals={15} />
                                                            <Input disabled={applySameWorkHours || other.status === 'Completed' || viewTimeSheet.clockOut} type={'number'} inputMode={'numeric'} value={otherUser.breakMinutes} setValue={v => { setFillingFor(fillingFor.map(r => r.id === otherUser.id ? { ...r, breakMinutes: v } : r)) }} placeholder={'0'} label={'Break (mins)'} />

                                                            {otherUser.clockIn && otherUser.clockOut &&
                                                                <Input disabled={true} type={'number'} label={'Hours'} value={getQuarterHoursFromTimes({ clockIn: otherUser.clockIn, clockOut: otherUser.clockOut, breakMinutes: otherUser.breakMinutes, breakIncludedInPay: !!otherUser.breakIncludedInPay, minuteOffset: 1 })} />
                                                            }
                                                        </div>
                                                    </div>)
                                                }
                                            </div>)
                                        }
                                    </>
                                )}
                            </Section>
                        </>}

                        {!mobileWorkerTimesheet && <>                         <Section
                            title={'Supervisor Sign Off'}
                            className='width-100'
                            variant='card'
                            collapsible={!mobileWorkerTimesheet}
                            expanded={workerTimesheetSections.supervisorSignOff}
                            onToggle={(nextValue) => setWorkerTimesheetSectionOpen('supervisorSignOff', nextValue)}
                        >
                            <div className='workerTimesheetSupervisorStack'>
                                <Checkbox disabled={viewTimeSheet.clockOut} value={supervisorNotAvailable} setValue={setSupervisorNotAvailable} label={'No one on site to sign off'} />
                                {
                                    !supervisorNotAvailable && <>
                                        <div className='workerTimesheetSupervisorField'>
                                            <Input disabled={viewTimeSheet.clockOut} value={supervisorName} setValue={setSupervisorName} placeholder={'Supervisor Name'} label={'Supervisor Name'} required />
                                        </div>
                                        <div className='workerTimesheetSignatureWrap'>
                                            {viewTimeSheet.clockOut ?
                                                (supervisorSign && <img src={supervisorSign} alt='Supervisor signature' style={{ width: '100%', maxWidth: '320px', height: '200px', objectFit: 'contain' }} />)
                                                :
                                                <SignatureCanvas penColor='black'
                                                    ref={signatureRef}
                                                    onEnd={() => { setTriggerStateUpdate(triggerStateUpdate + 1) }}
                                                    canvasProps={{ width: 320, height: 200, className: `sigCanvas workerTimesheetSignatureCanvas` }} />}
                                        </div>
                                    </>
                                }
                            </div>
                        </Section> </>}


                        <div className='allocationFooterActions'>
                            <div />
                            <div className='allocationFooterActionGroup'>
                                <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton' onClick={() => { setViewTimeSheet(false) }}>Cancel</Button>
                                <Button data-action-tone="save" variant="soft" size="md"  className='saveWithIcon' style={{marginTop: 0}} disabled={loading || (isWorker && !!viewTimeSheet?.clockOut) || !clockIn || !clockOut || (!supervisorNotAvailable && (!supervisorName.trim() || (mobileWorkerTimesheet ? !supervisorSign : !signatureRef.current || signatureRef.current.isEmpty())))} onClick={handleSaveTimeSheet}>Save</Button>
                            </div>
                        </div>
                        </div>

                    </> :
                        viewingWorker ? <>
                            <div className={[
                                'workerProfileDetailShell',
                                isNewWorker ? 'workerNewWorkerModal' : '',
                                !isNewWorker ? 'workerExistingProfileModal' : '',
                                showingWorkerAllocations ? 'workerAllocationsOnly' : '',
                                isWorker && !showingWorkerAllocations ? 'workerProfileWorkerDetail' : '',
                            ].filter(Boolean).join(' ')}>
                                <div className='workerProfileToolbar'>
                                    {isNewWorker && (
                                        <div className='workerNewWorkerTitleBlock'>
                                            <h3 className='pageTitle'>New Worker</h3>
                                            <p className='pageSubtitle'>Add the worker’s profile and employment details.</p>
                                        </div>
                                    )}
                                    {!isNewWorker && (
                                        <div className='workerExistingWorkerTitleBlock'>
                                            <h3 className='pageTitle'>Worker Profile</h3>
                                            <p className='pageSubtitle'>{formatWorkerName(formatName(`${firstName || ''} ${lastName || ''}`)) || 'Worker details'}</p>
                                        </div>
                                    )}
                                    {(editing ?
                                        <div className='recordHeaderActions'>
                                            <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton workerTopActionButton' onClick={() => {
                                                if (isNewWorker) {
                                                    closeWorkerPanel(viewingWorker?.id || '')
                                                    return
                                                }
                                                setEditing(false)
                                                setInformation()
                                            }}>Cancel</Button>
                                            <Button data-action-tone="save" variant="soft" size="md"  className='workerTopActionButton saveWithIcon' disabled={(isAdmin && (workerType.length === 0 || !userType)) || !firstName || !lastName || !email || !contactNo || loading || uploading || (viewingWorker.id && isWorker && (hasNotFilledBasicInfo || hasNotFilledTrafficInfo))} onClick={handleSaveWorkerInfo}>Save</Button>
                                        </div>
                                        : <div className='recordHeaderActions'>
                                            <Button variant="secondary" size="md" className='secondaryButton workerTopActionButton' onClick={() => {
                                                if (isWorker) {
                                                    navigate('/worker/overview')
                                                    return
                                                }
                                                closeWorkerPanel(viewingWorker?.id || '')
                                            }}>Cancel</Button>
                                            {isAdmin && needsReview(viewingWorker) && <Button variant="secondary" size="md" className='workerTopActionButton' disabled={loading} onClick={() => handleApproveReview(viewingWorker)}>Approve</Button>}
                                            {isAdmin && !!viewingWorker?.id && !viewingWorker?.archived && (
                                                <Button data-action-tone="archive" variant="secondary" size="md"
                                                    className='secondaryButton workerTopActionButton workerArchiveButton'
                                                    disabled={loading}
                                                    onClick={() => setConfirmMessage({
                                                        title: 'Archive Worker',
                                                        message: 'Archive this worker? Archived workers are hidden from dropdowns and can be restored later.',
                                                        confirmLabel: 'Archive',
                                                        action: () => handleArchiveWorker(viewingWorker),
                                                    })}
                                                >
                                                    Archive
                                                </Button>
                                            )}
                                            {isAdmin && !!viewingWorker?.id && !!viewingWorker?.archived && (
                                                <Button variant="secondary" size="md"
                                                    className='secondaryButton workerTopActionButton'
                                                    disabled={loading}
                                                    onClick={() => setConfirmMessage({
                                                        title: 'Restore Worker',
                                                        message: 'Restore this archived worker to active lists and dropdowns?',
                                                        confirmLabel: 'Restore',
                                                        action: () => handleRestoreWorker(viewingWorker),
                                                    })}
                                                >
                                                    Restore
                                                </Button>
                                            )}
                                            {isAdmin && !!viewingWorker?.id && (
                                                <Button data-action-tone="delete" variant="danger" size="md"
                                                    className='allocationDangerButton workerTopActionButton'
                                                    disabled={loading}
                                                    onClick={() => setConfirmMessage({
                                                        title: 'Delete Worker',
                                                        message: 'Delete this worker completely? This only works if they have never had a shift or allocation.',
                                                        confirmLabel: 'Delete',
                                                        action: () => handleDeleteWorker(viewingWorker),
                                                    })}
                                                >
                                                    Delete
                                                </Button>
                                            )}
                                            <Button data-action-tone="edit" variant="secondary" size="md"  className='workerTopActionButton actionWithIcon' disabled={loading} onClick={() => startEditingWorker()}><EditIcon />Edit</Button>
                                        </div>)}
                                </div>
                                {isAdmin && viewingWorker?.archived && (
                                    <div className='recordNoticeBar'>This worker is archived and hidden from allocation dropdowns.</div>
                                )}
                                <div className='workerProfileTopRow'>
                                    <Section title={isWorker ? 'Status' : 'Capacity / Status'} className={`workerProfileCard workerTypeStatusCard${isAdmin ? ' workerStatusHeaderTint' : ''}`} variant='card'>
                                        <div className='workerProfileFieldGrid workerProfileFieldGridTwo'>
                                            {viewingWorker.id &&
                                                <div>
                                                    <Dropdown
                                                        disabled={!editing || isWorker}
                                                        label={isWorker ? 'Profile Status' : 'Worker Status'}
                                                        required
                                                        options={workerStatuses.map(r => ({ label: r, value: r }))}
                                                        value={getDropdownValue(status, workerStatuses.map(r => ({ label: r, value: r })))}
                                                        setValue={v => setStatus(v.value)}
                                                    />
                                                </div>
                                            }

                                            <div>

                                                <Dropdown
                                                    isMulti
                                                    disabled={!editing || isWorker}
                                                    label={isWorker ? 'Worker Capacity' : 'Capacity'}
                                                    required
                                                    options={workerTypes.map(r => ({ label: r, value: r }))}
                                                    value={getDropdownValue(workerType, workerTypes.map(r => ({ label: r, value: r })), true)}
                                                    setValue={v => setWorkerType((v || []).map(x => x.value))}
                                                />

                                            </div>
                                            <div>
                                                <Dropdown
                                                    disabled={!editing || isWorker}
                                                    label={isWorker ? 'Worker Type' : 'User Type'}
                                                    required
                                                    options={userTypes.map(r => ({ label: r, value: r }))}
                                                    value={getDropdownValue(userType, userTypes.map(r => ({ label: r, value: r })))}
                                                    setValue={v => setUserType(v.value)}
                                                />

                                            </div>
                                            {isAdmin && viewingWorker?.id && (
                                                <div className='workerProfileCopyField'>
                                                    <Button variant="secondary" size="md"
                                                        className='textButton workerProfileCopyButton'
                                                        onClick={() => copyText(buildWorkerDetailsText({
                                                            firstName,
                                                            lastName,
                                                            contactNo,
                                                            email,
                                                            dob,
                                                        }), 'Worker details')}
                                                    >
                                                        <CopyIcon />Copy Worker Details
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </Section>

                                    <Section title={'Personal Details'} className='workerProfileCard workerPersonalDetailsCard' variant='card'>
                                        <div className='workerProfileFieldGrid workerProfileFieldGridTwo'>
                                            <Input disabled={!editing} value={firstName} setValue={v => setFirstName(capitalizeFirstLetter(v))} placeholder={'First Name'} label={'First Name'} required />
                                            <Input disabled={!editing} value={lastName} setValue={v => setLastName(capitalizeFirstLetter(v))} placeholder={'Last Name'} label={'Last Name'} required />
                                            <Input disabled={!editing || viewingWorker.email} value={email} setValue={setEmail} placeholder={'Email'} label={'Email'} required />
                                            <Input disabled={!editing} value={contactNo} setValue={v => setContactNo(removeWhitespace(v))} placeholder={'+61'} label={'Contact Number'} required />
                                            {!isNewWorker && <>
                                                <MyCalendar disabled={!editing} showDateOnly showYearDropdown startDate={dob} setStartDate={setDob} label={'Date of Birth'} />
                                                <div>
                                                    <FieldLabel className="fieldLabel">Address {viewingWorker.email && <span className='requiredMark'>*</span>}</FieldLabel>
                                                    <UiInput as={AutoComplete}
                                                        key={viewingWorker?.id || 'new-worker'}
                                                        disabled={!editing}
                                                        apiKey={googleApiKey}
                                                        options={{
                                                            types: ["address"],
                                                            componentRestrictions: { country: "au" },
                                                        }}
                                                        defaultValue={address}
                                                        onPlaceSelected={(place) => { setCoordinates([place.geometry.location.lat(), place.geometry.location.lng()]); setAddress(place.formatted_address); }}
                                                        className='workerAutocompleteField'
                                                    />
                                                </div>
                                                <div className='workerProfileFieldSpanFull'>
                                                    <MyDropzone key={`profile-pic-${viewingWorker?.id || 'new'}`} setUploading={setUploading} disabled={!editing} storageLocation={`ProfilePic/${randomString()}`} label={'Profile Pic'} customMessage={'Click here/Drop files here to upload'} editing={true} errors={[]} name={'document'} image={profilePic} updateImage={guardWorkerUpload(setProfilePic)} ownerWorkerId={viewingWorker?.id || ''} />
                                                </div>
                                            </>}
                                        </div>

                                    </Section>
                                </div>


                                {isNewWorker && <div className='workerProfileSectionStack'>{renderWorkerLicences()}</div>}
                                {viewingWorker.id && (
                                    <div className='workerProfileSectionStack'>
                                        <div className='workerProfileInfoRow workerProfileInfoRowThree'>

                                            <Section title={'Accounts'} className='workerProfileCard' variant='card'>
                                                <div className='workerProfileFieldGrid workerProfileFieldGridTwo'>
                                                    <Input disabled={!editing} value={bankName} setValue={setBankName} placeholder={'Bank Name'} label={'Bank Name'} required />
                                                    <Input disabled={!editing} value={accountName} setValue={setAccountName} placeholder={'Account Name'} label={'Account Name'} required />
                                                    <Input disabled={!editing} value={bsb} setValue={v => setBsb(removeWhitespace(v))} placeholder={'BSB'} label={'BSB'} required />
                                                    <Input disabled={!editing} value={accountNumber} setValue={v => setAccountNumber(removeWhitespace(v))} placeholder={'Account Number'} label={'Account Number'} required />
                                                    <Input disabled={!editing} value={abn} setValue={v => setAbn(removeWhitespace(v))} placeholder={'ABN'} label={'ABN'} required />
                                                    {isAdmin && abn && <div className='workerProfileFieldSpanFull workerProfileAbnBlock'>
                                                        <Button variant="secondary" size="md" className='workerInlineButton' disabled={!abn || removeWhitespace(abn).length !== 11} onClick={handleAbnLookup}>Verify ABN</Button>
                                                        <Dropdown label={'Matched Name'} disabled={abnNameOptions.length === 0} required options={abnNameOptions} value={getDropdownValue(abnMatchedName, abnNameOptions)} setValue={v => { setAbnMatchedName(v.value); setAbnVerified(false) }} />
                                                        <div className='workerProfileAbnActions'>
                                                            {/* Verifying saves the whole profile, so it runs on the saved profile, not unsaved edits. */}
                                                            <Button variant="secondary" size="md" className='workerInlineButton' title={editing ? 'Save your changes before verifying the ABN' : undefined} disabled={editing || loading || !abnMatchedName || abnVerified} onClick={handleVerifyAbn}>Verify ABN</Button>
                                                            {abnVerified && <span className='verifiedBadge'>ABN Verified</span>}
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </Section>

                                            <Section title={'Emergency Contact'} className='workerProfileCard' variant='card'>
                                                <div className='workerProfileFieldGrid workerProfileFieldGridThree'>
                                                    <Input disabled={!editing} value={emergencyFirstName} setValue={setEmergencyFirstName} placeholder={'First Name'} label={'First Name'} required />
                                                    <Input disabled={!editing} value={emergencyLastName} setValue={setEmergencyLastName} placeholder={'Last Name'} label={'Last Name'} required />
                                                    <Input disabled={!editing} value={emergencyContactNo} setValue={setEmergencyContactNo} placeholder={'Contact Number'} label={'Contact Number'} required />
                                                </div>
                                            </Section>
                                        <Section title={'Medical Checklist'} className='width-100 workerProfileCard' variant='card'>
                                            {/* <Input disabled={!editing} value={preExistingInjuries} setValue={setPreExistingInjuries} placeholder={'No / List them'} label={'Pre-existing Injuries'} required />
                                    <Input disabled={!editing} value={prescribedMedication} setValue={setPrescribedMedication} placeholder={'No / List them'} label={'Prescribed Medications'} required />
                                    <Input disabled={!editing} value={medicalConditions} setValue={setMedicalConditions} placeholder={'No / List them'} label={'Medical Conditions'} required />
                                    <Input disabled={!editing} value={allergies} setValue={setAllergies} placeholder={'Allergies'} label={'Allergies'} required /> */}

                                            <div className='workerProfileFieldGrid workerProfileFieldGridTwo workerProfileMedicalGrid'>
                                                <div className='workerProfileMedicalItem'>
                                                    <Dropdown
                                                        disabled={!editing}
                                                        label={'Pre-existing Injuries'}
                                                        required
                                                        options={['Yes', 'No'].map(r => ({ label: r, value: r }))}
                                                        value={getDropdownValue(preExistingInjuriesYN, ['Yes', 'No'].map(r => ({ label: r, value: r })))}
                                                        setValue={v => setPreExistingInjuriesYN(v.value)}
                                                    />
                                                    {preExistingInjuriesYN === 'Yes' && (
                                                        <Input
                                                            disabled={!editing}
                                                            value={preExistingInjuries}
                                                            setValue={setPreExistingInjuries}
                                                            placeholder={'Please describe injuries'}
                                                            label={'Describe Injuries'}
                                                            required
                                                        />
                                                    )}
                                                </div>

                                                <div className='workerProfileMedicalItem'>
                                                    <Dropdown
                                                        disabled={!editing}
                                                        label={'Prescribed Medications'}
                                                        required
                                                        options={['Yes', 'No'].map(r => ({ label: r, value: r }))}
                                                        value={getDropdownValue(prescribedMedicationYN, ['Yes', 'No'].map(r => ({ label: r, value: r })))}
                                                        setValue={v => setPrescribedMedicationYN(v.value)}
                                                    />
                                                    {prescribedMedicationYN === 'Yes' && (
                                                        <Input
                                                            disabled={!editing}
                                                            value={prescribedMedication}
                                                            setValue={setPrescribedMedication}
                                                            placeholder={'Please list medications'}
                                                            label={'List Medications'}
                                                            required
                                                        />
                                                    )}
                                                </div>

                                                <div className='workerProfileMedicalItem'>
                                                    <Dropdown
                                                        disabled={!editing}
                                                        label={'Medical Conditions'}
                                                        required
                                                        options={['Yes', 'No'].map(r => ({ label: r, value: r }))}
                                                        value={getDropdownValue(medicalConditionsYN, ['Yes', 'No'].map(r => ({ label: r, value: r })))}
                                                        setValue={v => setMedicalConditionsYN(v.value)}
                                                    />
                                                    {medicalConditionsYN === 'Yes' && (
                                                        <Input
                                                            disabled={!editing}
                                                            value={medicalConditions}
                                                            setValue={setMedicalConditions}
                                                            placeholder={'Please describe conditions'}
                                                            label={'Describe Conditions'}
                                                            required
                                                        />
                                                    )}
                                                </div>

                                                <div className='workerProfileMedicalItem'>
                                                    <Dropdown
                                                        disabled={!editing}
                                                        label={'Allergies'}
                                                        required
                                                        options={['Yes', 'No'].map(r => ({ label: r, value: r }))}
                                                        value={getDropdownValue(allergiesYN, ['Yes', 'No'].map(r => ({ label: r, value: r })))}
                                                        setValue={v => setAllergiesYN(v.value)}
                                                    />
                                                    {allergiesYN === 'Yes' && (
                                                        <Input
                                                            disabled={!editing}
                                                            value={allergies}
                                                            setValue={setAllergies}
                                                            placeholder={'Please describe allergies'}
                                                            label={'Describe Allergies'}
                                                            required
                                                        />
                                                    )}
                                                </div>
                                                <div className='workerProfileFieldSpanFull'>
                                                    <Input
                                                        disabled={!editing}
                                                        value={medicalOther}
                                                        setValue={setMedicalOther}
                                                        placeholder={'Other medical information'}
                                                        label={'Other'}
                                                    />
                                                </div>
                                            </div>

                                        </Section>
                                        </div>

                                        {activeOrg && activeOrg.role === 'admin' && <Section title={'Rates'} className='width-100 workerProfileCard' variant='card'>


                                            {userType === 'Contractor' ? (
                                                <ContractorRatesTable
                                                    rates={contractorRates}
                                                    setRates={setContractorRates}
                                                    editing={editing}
                                                />
                                            ) : (
                                                <EmployeeRatesTable
                                                    rates={employeeRates}
                                                    setRates={setEmployeeRates}
                                                    editing={editing}
                                                />
                                            )}

                                        </Section>}
                                        {renderWorkerLicences()}
                                        {isAdmin && viewingWorker?.id && <Section title='Site Feedback & Restrictions' className='width-100 workerProfileCard' variant='card'><SiteWorkerComments key={viewingWorker.id} orgId={activeOrg.id} workerId={viewingWorker.id} /></Section>}
                                        {isAdmin && viewingWorker?.id && (
                                            <Section title={'Worker History'} className='width-100 workerProfileCard' variant='card'>
                                                {workerHistoryRows.length === 0 ? (
                                                    <p className='workerProfileEmptyText'>No worker history yet.</p>
                                                ) : (
                                                    <>
                                                    <div className='workerProfileTableWrap'>
                                                        <Table emptyItems="allocations" className='workersDirectoryTable workerProfileTable'>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableHeaderCell>Date/Time</TableHeaderCell>
                                                                    <TableHeaderCell>Allocation ID</TableHeaderCell>
                                                                    <TableHeaderCell>Client</TableHeaderCell>
                                                                    <TableHeaderCell>Site</TableHeaderCell>
                                                                    <TableHeaderCell>Status</TableHeaderCell>
                                                                    <TableHeaderCell>Action</TableHeaderCell>
                                                                    <TableHeaderCell>Comments</TableHeaderCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <tbody>
                                                                {paginatedWorkerHistoryRows.map(row => (
                                                                    <TableRow key={`worker-history-${row.id}`}>
                                                                        <TableCell>{row.workerResponseAt || row.date ? <>{format(new Date(row.workerResponseAt || row.date), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(row.workerResponseAt || row.date))}</> : '-'}</TableCell>
                                                                        <TableCell>{row.allocationNumber || row.allocationId || '-'}</TableCell>
                                                                        <TableCell>{row.clientName || row.client || '-'}</TableCell>
                                                                        <TableCell>{row.siteName || row.site || '-'}</TableCell>
                                                                        <TableCell>{row.workerResponseAction === 'Cancel' ? 'Cancelled' : row.workerResponse === 'Reject' ? 'Rejected' : (row.status || 'Pending')}</TableCell>
                                                                        <TableCell>
                                                                            <Button variant="secondary" size="sm" className='textButton' onClick={() => navigate(`/timesheet?timesheetId=${row.id}`, { state: { returnTo: `${location.pathname}${location.search}` } })}>View</Button>
                                                                            {editingWorkerHistoryId !== row.id && (
                                                                                <Button data-action-tone="edit" variant="secondary" size="sm" className='textButton' onClick={() => setEditingWorkerHistoryId(row.id)}>Edit</Button>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell className='workerProfileCommentCell'>
                                                                            {row.workerResponseComment ? (
                                                                                <div className='workerProfileCommentText'>
                                                                                    <strong>Worker:</strong> {row.workerResponseComment}
                                                                                </div>
                                                                            ) : null}
                                                                            {editingWorkerHistoryId === row.id ? (
                                                                                <div className='workerProfileCommentEditor'>
                                                                                    <Textarea
                                                                                        className='workerProfileCommentTextarea'
                                                                                        value={workerHistoryComments[row.id] || ''}
                                                                                        onChange={(event) => setWorkerHistoryComments(prev => ({ ...prev, [row.id]: event.target.value }))}
                                                                                        placeholder='Add admin note'
                                                                                    />
                                                                                    <div className='workerProfileCommentMetaRow'>
                                                                                        <span className='workerProfileCommentMetaText'>
                                                                                            {row.adminHistoryCommentUpdatedAt ? <>Updated {format(new Date(row.adminHistoryCommentUpdatedAt), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(row.adminHistoryCommentUpdatedAt))}{row.adminHistoryCommentUpdatedByName ? ` by ${row.adminHistoryCommentUpdatedByName}` : ''}</> : ''}
                                                                                        </span>
                                                                                        <Button data-action-tone="save" variant="soft" size="sm"
                                                                                            className='textButton saveWithIcon'
                                                                                            disabled={workerHistorySavingId === row.id}
                                                                                            onClick={() => saveWorkerHistoryComment(row.id)}
                                                                                        >
                                                                                            Save
                                                                                        </Button>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div className='workerProfileCommentEditor'>
                                                                                    <div className='workerProfileCommentText'>
                                                                                        {workerHistoryComments[row.id] ? <><strong>Admin:</strong> {workerHistoryComments[row.id]}</> : (row.workerResponseComment ? null : '-')}
                                                                                    </div>
                                                                                    <div className='workerProfileCommentMetaRow'>
                                                                                        <span className='workerProfileCommentMetaText'>
                                                                                            {row.adminHistoryCommentUpdatedAt ? <>Updated {format(new Date(row.adminHistoryCommentUpdatedAt), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(row.adminHistoryCommentUpdatedAt))}{row.adminHistoryCommentUpdatedByName ? ` by ${row.adminHistoryCommentUpdatedByName}` : ''}</> : ''}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    <div className='invoicePagination'>
                                                        <Button variant="secondary" size="md" type='button' disabled={workerHistoryPage === 1} onClick={() => setWorkerHistoryPage(page => Math.max(1, page - 1))}>Previous</Button>
                                                        <span>Page {workerHistoryPage} of {workerHistoryPageCount}</span>
                                                        <Button variant="secondary" size="md" type='button' disabled={workerHistoryPage === workerHistoryPageCount} onClick={() => setWorkerHistoryPage(page => Math.min(workerHistoryPageCount, page + 1))}>Next</Button>
                                                    </div>
                                                    </>
                                                )}
                                            </Section>
                                        )}
                                        {isAdmin && viewingWorker?.id && (
                                            <Section title={'Audit Log'} className='width-100 workerProfileCard' variant='card'>
                                                {workerAuditLoading ? (
                                                    <p className='workerProfileEmptyText'>Loading audit log...</p>
                                                ) : workerAuditLogs.length === 0 ? (
                                                    <p className='workerProfileEmptyText'>No audit entries yet.</p>
                                                ) : (
                                                    <>
                                                    <div className='workerProfileTableWrap'>
                                                        <Table emptyItems="activity entries" className='workersDirectoryTable workerProfileTable'>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableHeaderCell>Timestamp</TableHeaderCell>
                                                                    <TableHeaderCell>Event</TableHeaderCell>
                                                                    <TableHeaderCell>By</TableHeaderCell>
                                                                    <TableHeaderCell>Details</TableHeaderCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <tbody>
                                                                {paginatedWorkerAuditLogs.map(log => (
                                                                    <TableRow key={log.id}>
                                                                        <TableCell>{log.createdAt ? <>{format(new Date(log.createdAt), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(log.createdAt))}</> : '-'}</TableCell>
                                                                        <TableCell>{log.message || log.eventType || '-'}</TableCell>
                                                                        <TableCell>{formatName(log.actorName) || log.actorEmail || '-'}</TableCell>
                                                                        <TableCell>
                                                                            {Array.isArray(log.changedFields) && log.changedFields.length > 0 ? (
                                                                                <div className='workerProfileAuditDetailList'>
                                                                                    {log.changedFields.map(field => (
                                                                                        <div key={`${log.id}-${field.field}`}>
                                                                                            <strong>{field.label}</strong>: {field.before || '-'} to {field.after || '-'}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            ) : (
                                                                                log.status || '-'
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    <div className='invoicePagination'>
                                                        <Button variant="secondary" size="md" type='button' disabled={workerAuditPage === 1} onClick={() => setWorkerAuditPage(page => Math.max(1, page - 1))}>Previous</Button>
                                                        <span>Page {workerAuditPage} of {workerAuditPageCount}</span>
                                                        <Button variant="secondary" size="md" type='button' disabled={workerAuditPage === workerAuditPageCount} onClick={() => setWorkerAuditPage(page => Math.min(workerAuditPageCount, page + 1))}>Next</Button>
                                                    </div>
                                                    </>
                                                )}
                                            </Section>
                                        )}
                                    </div>
                                )}
                            </div>
                        </> : <>

                            {isWorker && showingWorkerAllocations && <>
                                <span id='worker-allocation-panels' />
                                <div className='workerAllocationCardsGrid' style={allocationTab ? { gridTemplateColumns: 'minmax(0, 1fr)' } : undefined}>
                                    {allocationTab !== 'accepted' && <Section title='Pending Allocations' className='workerAllocationListCard workerPendingAllocationCard' variant='card'>
                                        <div className='workerAllocationHeadingDivider' />
                                        <div className='workerAllocationTableWrap'>
                                            <Table className='workerAllocationTable'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableHeaderCell>Date & Time</TableHeaderCell>
                                                        <TableHeaderCell>Client</TableHeaderCell>
                                                        <TableHeaderCell>Site Name</TableHeaderCell>
                                                        <TableHeaderCell>Site Address</TableHeaderCell>

                                                        <TableHeaderCell>
                                                            Action
                                                        </TableHeaderCell>
                                                    </TableRow>
                                                </TableHead>
                                                <tbody>
                                                    {pendingWorkerAllocationRows.map(timeSheet => <TableRow key={timeSheet.id} className='workerAllocationPendingRow'>
                                                        <TableCell data-label='Date & Time' className='workerAllocationDateTimeCell workerAllocationDateTimeUnderlined'>
                                                            <button type='button' className='workerAllocationDateTimeLink' onClick={() => openTimeSheet(timeSheet.id)}>
                                                                {timeSheet.isGroupRow
                                                                    ? <><span>{format(new Date(timeSheet.groupStartDate), 'EEE, d MMM yyyy')} - {format(new Date(timeSheet.groupEndDate), 'EEE, d MMM yyyy')}</span><br /><span>{formatTime(new Date(timeSheet.date))}</span></>
                                                                    : <><span>{format(new Date(timeSheet.date), 'EEE, d MMM yyyy')}</span><br /><span>{formatTime(new Date(timeSheet.date))}</span></>}
                                                            </button>
                                                        </TableCell>
                                                        <TableCell data-label='Client'>{timeSheet.clientName}</TableCell>
                                                        <TableCell data-label='Site Name'>{timeSheet.siteName}</TableCell>
                                                         <TableCell data-label='Site Address'>{formatWorkerSiteAddress(getAllocationDisplayAddress(timeSheet))}</TableCell>
                                                         <TableCell data-label='Action' className='workerAllocationMobileActionCell'><div className='workerAllocationActionButtons'>{!timeSheet.status ? <>
                                                            <Button variant="secondary" size="icon" title='Accept allocation' aria-label='Accept allocation' className='workerAllocationAction workerAllocationActionAccept workerOverviewIconAction' onClick={event => { event.stopPropagation(); setConfirmMessage({
                                                                 title: 'Accept Allocation',
                                                                 message: 'Are you sure you want to accept this allocation?',
                                                                 confirmLabel: 'Accept',
                                                                 action: () => handleRespondAllocation(timeSheet, 'Accept'),
                                                            }) }}><VerifiedIcon /></Button>
                                                            <Button variant="secondary" size="icon" title='Reject allocation' aria-label='Reject allocation' className='workerAllocationAction workerAllocationActionReject workerOverviewIconAction' onClick={event => { event.stopPropagation();
                                                                 confirmRejectAllocation(timeSheet)
                                                            }}><XIcon /></Button>
                                                        </> :
                                                            <Button variant="secondary" size="sm" className='textButton' onClick={() => { openTimeSheet(timeSheet.id) }}>View</Button>
                                                        }</div></TableCell>
                                                    </TableRow>)}
                                                    {pendingWorkerAllocationRows.length === 0 && <TableEmpty  colSpan={5}>No allocations yet.</TableEmpty>}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Section>}

                                    {allocationTab !== 'pending' && <Section title='Accepted Allocations' className='workerAllocationListCard workerAcceptedAllocationCard' variant='card'>
                                        <div className='workerAllocationHeadingDivider' />
                                        <div className='workerAllocationTableWrap'>
                                            <Table className='workerAllocationTable'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableHeaderCell>Date & Time</TableHeaderCell>
                                                        <TableHeaderCell>Client</TableHeaderCell>
                                                        <TableHeaderCell>Site Address</TableHeaderCell>
                                                        <TableHeaderCell>
                                                            Shift Start
                                                        </TableHeaderCell>
                                                    </TableRow>
                                                </TableHead>
                                                <tbody>
                                                    {upcomingRowsForDisplay.map(timeSheet => <TableRow key={timeSheet.id}>
                                                        <TableCell data-label='Date & Time' className='workerAllocationDateTimeCell workerAllocationDateTimeUnderlined'><button type='button' className='workerAllocationDateTimeLink' onClick={() => openTimeSheet(timeSheet.id)}><span>{format(new Date(timeSheet.date), 'EEE, d MMM yyyy')}</span><br /><span>{formatTime(new Date(timeSheet.date))}</span></button></TableCell>
                                                        <TableCell data-label='Client'>{timeSheet.clientName}</TableCell>
                                                        <TableCell data-label='Site Address'>{formatWorkerSiteAddress(getAllocationDisplayAddress(timeSheet))}</TableCell>
                                                        <TableCell data-label='Shift Start'>{timeSheet.clockIn ? <>{format(new Date(timeSheet.clockIn), 'EEE, d MMM yyyy')}<br />{formatTime(new Date(timeSheet.clockIn))}</> : '-'}</TableCell>
                                                    </TableRow>)}
                                                    {upcomingRowsForDisplay.length === 0 && <TableEmpty  colSpan={4}>No allocations yet.</TableEmpty>}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Section>}
                                </div>


                                {chosenInvoice && <InvoiceGenerator isWorker={true}
                                    shouldUploadAndSendInvoice={shouldUploadAndSendInvoice}
                                    logo={typeof activeOrgInfo?.logo === 'string' ? activeOrgInfo.logo : activeOrgInfo?.logo?.url}
                                    setChosenInvoice={setChosenInvoice}
                                    updateInvoice={handleSendInvoice}
                                    setUploading={setUploading}
                                    invoice={memoInvoice}
                                />}
                                <ModalComponent customMaxWidth={'95%'} showModal={!!showAdditionalJobs} setShowModal={setShowAdditionalJobs} >
                                    <h2 className='modalTitle'>Additional Jobs</h2>
                                    <Table emptyItems="line items">
                                        <TableHead>
                                            <TableRow>
                                                <TableHeaderCell>Date/Time</TableHeaderCell>
                                                <TableHeaderCell>Description</TableHeaderCell>
                                                <TableHeaderCell>Rate</TableHeaderCell>
                                                <TableHeaderCell>Quantity</TableHeaderCell>
                                                <TableHeaderCell>GST</TableHeaderCell>
                                                <TableHeaderCell>Total</TableHeaderCell>
                                                <TableHeaderCell>Action</TableHeaderCell>
                                            </TableRow>
                                        </TableHead>
                                        <tbody>
                                            {
                                                additionalJobs && additionalJobs.map((row, index) => <TableRow key={`row-${index}`}>
                                                    <TableCell>{row.time}</TableCell>
                                                    <TableCell>{row.description}</TableCell>
                                                    <TableCell>{formatCurrency(row.rate)}</TableCell>
                                                    <TableCell>{row.quantity}</TableCell>
                                                    <TableCell>${calculateAdditionalJobRowGst(row).toFixed(2)}</TableCell>
                                                    <TableCell>${calculateAdditionalJobRowSubTotal(row).toFixed(2)}</TableCell>
                                                    <TableCell>
                                                        <Button data-action-tone="edit" variant="secondary" size="sm"  className='textButton actionWithIcon' onClick={() => { handleEditJob(row, index) }}><EditIcon />Edit</Button>
                                                        <Button data-action-tone="delete" variant="danger" size="sm"  className='textButton' onClick={() => { setAdditionalJobs([...additionalJobs].filter((r, idx) => idx !== index)) }}>Delete</Button>
                                                    </TableCell>
                                                </TableRow>)
                                            }
                                        </tbody>
                                    </Table>

                                    <Button variant="create" size="md" type='button' className='textButton' style={{marginTop: '12px'}} onClick={() => { setAdditionalJobs([...additionalJobs, { description: '', rate: '', quantity: '', time: '', gst: 0, total: 0, subtotal: 0 }]); setShowAdditionalJobIndex(additionalJobs.length); clearJobRateFields(); setShowEditAdditionalJob(true) }}>+ New Job</Button>

                                    <div className='modalFooter modalFooterSticky'>
                                        <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton' onClick={() => setShowAdditionalJobs(false)}>Cancel</Button>
                                        <Button data-action-tone="save" variant="soft" size="md"  className='saveWithIcon' style={{marginTop: 0}} disabled={false} onClick={handleSaveAdditionalJobs}>Save</Button>
                                    </div>
                                </ModalComponent>

                                <ModalComponent showModal={!!showEditAdditionalJob} setShowModal={setShowEditAdditionalJob} >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <h2 className='modalTitle'>Additional Job</h2>
                                        <MyCalendar disabled={false} showDateOnly showYearDropdown startDate={additionalJobTime} setStartDate={setAdditionalJobTime} label={'Date'} />

                                        <Input disabled={false} value={additionalJobDescription} setValue={setAdditionalJobDescription} placeholder={'Description'} label={'Description'} />
                                        <Input disabled={false} type={'numeric'} value={additionalJobRate} setValue={setAdditionalJobRate} placeholder={'Rate'} label={'Rate'} />
                                        <Input disabled={false} type={'numeric'} value={additionalJobQuantity} setValue={setAdditionalJobQuantity} placeholder={'Quantity'} label={'Quantity'} />
                                        <div className='detailGrid' style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', marginTop: '16px' }}>
                                            <div className='detailItem'><span className='detailLabel'>GST</span><span className='detailValue'>${(calculateAdditionalJobRowGst()).toFixed(2)}</span></div>
                                            <div className='detailItem'><span className='detailLabel'>Total</span><span className='detailValue'>${(calculateAdditionalJobRowSubTotal()).toFixed(2)}</span></div>
                                        </div>

                                        <div className='modalFooter'>
                                            <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton' onClick={() => { setShowEditAdditionalJob(false); clearJobRateFields() }}>Cancel</Button>
                                            <Button data-action-tone="save" variant="soft" size="md"  className='saveWithIcon' style={{marginTop: 0}} disabled={false} onClick={handleSaveEditAdditionalJob}>Save</Button>
                                        </div>
                                    </div>
                                </ModalComponent>

                                {/* {userInfo.userType !== 'Employee' && <>
                                    <h3 className='subPanelHeading'>Invoices</h3>

                                    <table>
                                        <thead>
                                            <tr>
                                                <th {...invoicesSort.getSortableHeaderProps('invoiceNumber')}>
                                                    Number {invoicesSort.getSortIcon('invoiceNumber')}
                                                </th>

                                                <th {...invoicesSort.getSortableHeaderProps('date')}>
                                                    Date {invoicesSort.getSortIcon('date')}
                                                </th>
                                                <th {...invoicesSort.getSortableHeaderProps('workerName')}>
                                                    Worker {invoicesSort.getSortIcon('workerName')}
                                                </th>
                                                <th>
                                                    Status
                                                </th>
                                                <th>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                invoicesSort.sortedData.map(invoice => <tr key={invoice.id}>
                                                    <td className='hover' onClick={() => { setShouldUploadAndSendInvoice(false); setChosenInvoice(invoice) }}><span className='allocationDateLink'>{invoice.invoiceNumber}</span></td>
                                                    <td>{format(new Date(invoice.date), 'EEE, d MMM yyyy')}</td>
                                                    <td>{formatWorkerName(invoice.workerName)}</td>
                                                    <td>{invoice.status || 'Created'}</td>
                                                    <td>
                                                        {(invoice.status === 'Created' || invoice.status === 'Modified') && <button className="textButton" onClick={() => { setAdditionalJobsModifyingInvoice(invoice); setAdditionalJobs(invoice.additionalJobs || []); setShowAdditionalJobs(true) }}>Modify</button>}
                                                        {(invoice.status === 'Created' || invoice.status === 'Modified') && <button className="textButton" onClick={() => { setShouldUploadAndSendInvoice(true); setChosenInvoice(invoice) }}>Send</button>}
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                </>} */}
                            </>}

                            {userInfo && activeOrg && activeOrg.role === 'admin' ? (
                                <Section title={'Workers'} className='width-100 workerProfileCard workersDirectorySection' variant='card'>
                                    <div className='workersDirectoryToolbar'>
                                        <div className='workersDirectoryTopRow'>
                                            <Tabs className='workersDirectoryTabs'>
                                                {[
                                                    { key: 'workers', label: `All Workers (${filteredWorkers.length})`, icon: <UsersIcon /> },
                                                    { key: 'pending', label: `Pending Review (${pendingWorkers.length})`, icon: <ClockIcon /> },
                                                    ...(isAdmin ? [{ key: 'archived', label: `Archived (${archivedWorkers.length})`, icon: <ArchiveIcon /> }] : []),
                                                ].map(tab => (
                                                    <Tabs.Tab active={workerListTab === tab.key}
                                                        key={tab.key}
                                                        className={workerListTab === tab.key ? 'workersDirectoryTab workersDirectoryTabActive' : 'workersDirectoryTab'}
                                                        onClick={() => {
                                                            setWorkerListTab(tab.key)
                                                            const nextParams = new URLSearchParams(searchParams)
                                                            if (tab.key === 'workers') {
                                                                nextParams.delete('tab')
                                                            } else {
                                                                nextParams.set('tab', tab.key)
                                                            }
                                                            setSearchParams(nextParams)
                                                        }}
                                                    >
                                                        <span className='workersDirectoryTabIcon'>{tab.icon}</span>
                                                        <span>{tab.label}</span>
                                                    </Tabs.Tab>
                                                ))}
                                            </Tabs>
                                            <div className='workersDirectoryActions'>
                                                <Button variant="secondary" size="md"
                                                    type='button'
                                                    className='allocationNewButton workersOnLeaveToolbarButton'
                                                    onClick={() => {
                                                        setWorkerLeavesAccordionExpanded(true)
                                                        setLeaveTab('upcoming')
                                                        setTimeout(() => {
                                                            const leaveCard = document.querySelector('.workerLeavesSection')
                                                            if (!leaveCard) return
                                                            const top = leaveCard.getBoundingClientRect().top + window.scrollY - 16
                                                            window.scrollTo({ top, behavior: 'smooth' })
                                                        }, 50)
                                                    }}
                                                >
                                                    Workers on Leave
                                                </Button>
                                                <Button variant="create" size="md" className='allocationNewButton' onClick={() => { setViewingWorker({}); setEditing(true) }}>
                                                    <PlusIcon />
                                                    Worker
                                                </Button>
                                            </div>
                                        </div>
                                        <div className='workersDirectoryFilters'>
                                            <div className='workersDirectoryField workersDirectorySearchField'>

                                                <SearchInput disabled={false} value={workerSearch} onChange={event => (setWorkerSearch)(event.target.value)} placeholder={'Search'} />
                                            </div>
                                            <div className='workersDirectoryFilterLowerRow'>
                                                <div className='workersDirectoryField workersDirectoryTypeField'>
                                                    <Dropdown
                                                        clearable
                                                        options={workerTypes.map(type => ({ label: type, value: type }))}
                                                        value={getDropdownValue(workerTypeFilter, workerTypes.map(type => ({ label: type, value: type })))}
                                                        setValue={value => setWorkerTypeFilter(value?.value || '')}
                                                        placeholder={'All worker types'}
                                                    />
                                                </div>
                                                <div className='workersDirectoryAlphabet' aria-label='Filter workers by first-name initial'>
                                                <FilterChip active={!workerInitialFilter}
                                                    type='button'
                                                    className={!workerInitialFilter ? 'workersDirectoryLetter workersDirectoryLetterActive' : 'workersDirectoryLetter'}
                                                    onClick={() => setWorkerInitialFilter('')}
                                                >
                                                    All
                                                </FilterChip>
                                                {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => (
                                                    <FilterChip active={workerInitialFilter === letter}
                                                        key={letter}
                                                        type='button'
                                                        className={workerInitialFilter === letter ? 'workersDirectoryLetter workersDirectoryLetterActive' : 'workersDirectoryLetter'}
                                                        onClick={() => setWorkerInitialFilter(letter)}
                                                    >
                                                        {letter}
                                                    </FilterChip>
                                                ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='workerProfileTableWrap workersDirectoryTableScroll'>
                                        <Table className='workersDirectoryTable workerProfileTable'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableHeaderCell {...workersSort.getSortableHeaderProps('firstName')}>
                                                        Name
                                                    </TableHeaderCell>
                                                    <TableHeaderCell>
                                                        Number
                                                    </TableHeaderCell>
                                                    <TableHeaderCell>
                                                        Email
                                                    </TableHeaderCell>
                                                    <TableHeaderCell>
                                                        Status
                                                    </TableHeaderCell>
                                                    <TableHeaderCell>
                                                        Action
                                                    </TableHeaderCell>
                                                </TableRow>
                                            </TableHead>
                                            <tbody>
                                                {paginatedWorkerRows.map(worker => {
                                                    const statusLabel = worker.publicSignupApproved === false
                                                        ? 'Pending Review'
                                                        : worker.archived
                                                            ? 'Archived'
                                                            : (worker.status || 'Approved')
                                                    const rowIsPending = statusLabel === 'Pending Review'
                                                    const statusClassName = statusLabel === 'Pending Review'
                                                        ? 'workersDirectoryStatus workersDirectoryStatusPending'
                                                        : statusLabel === 'Archived'
                                                            ? 'workersDirectoryStatus workersDirectoryStatusArchived'
                                                            : statusLabel === 'Approved'
                                                                ? 'workersDirectoryStatus workersDirectoryStatusApproved'
                                                                : 'workersDirectoryStatus workersDirectoryStatusOther'
                                                    return <TableRow
                                                        key={worker.id}
                                                        className={rowIsPending ? 'workersDirectoryPendingRow' : ''}
                                                        ref={(node) => {
                                                            if (node) {
                                                                workerRowRefs.current.set(worker.id, node)
                                                            } else {
                                                                workerRowRefs.current.delete(worker.id)
                                                            }
                                                        }}
                                                    >
                                                        <TableCell
                                                            className={rowIsPending ? 'workersDirectoryAlertText hover' : 'hover'}
                                                            onClick={() => openWorkerPanel(worker)}
                                                        >
                                                            <span className='allocationDateLink'>{formatWorkerName(formatName(`${formatName(worker.firstName) || ''} ${formatName(worker.lastName) || ''}`))}</span>
                                                        </TableCell>
                                                        <TableCell className={rowIsPending ? 'workersDirectoryAlertText' : ''}>{formatPhone(worker.contactNo)}</TableCell>
                                                        <TableCell className={rowIsPending ? 'workersDirectoryAlertText' : ''}>{formatEmail(worker.email)}</TableCell>
                                                        <TableCell>
                                                            <span className={statusClassName}>
                                                                {statusLabel}
                                                            </span>
                                                            {worker.publicSignupApproved === false && <span className='workersDirectoryStatus workersDirectoryStatusOther' title='Signed up through the public form. Cannot be allocated until approved.'>Public sign-up</span>}
                                                        </TableCell>
                                                        <TableCell className='workersDirectoryActionCell'>
                                                            <Button variant="secondary" size="sm" className='workersDirectoryLinkButton workersDirectoryCopyDetailsButton' onClick={async () => { const response = worker._listOnly ? await postWithAuth('fetchWorkers', { orgId: activeOrg.id, recordId: worker.id }) : { data: [worker] }; if (response?.err) toast.error(response.err); else if (response?.data?.[0]) copyText(buildWorkerDetailsText(response.data[0]), 'Worker details') }}><CopyIcon />Details</Button>
                                                            {isAdmin && needsReview(worker) && <Button variant="secondary" size="sm" disabled={loading} className='workersDirectoryLinkButton workersDirectorySignupButton' onClick={() => { handleApproveReview(worker) }}><VerifiedIcon />Approve</Button>}
                                                            {isAdmin && worker.archived && <Button variant="secondary" size="sm" disabled={loading} className='workersDirectoryLinkButton' onClick={() => setConfirmMessage({ title: 'Restore Worker', message: 'Restore this archived worker to active lists and dropdowns?', confirmLabel: 'Restore', action: () => handleRestoreWorker(worker) })}>Restore</Button>}
                                                            {activeOrg && activeOrg.role === 'admin' && worker.signupSource !== 'public' && (!worker.status || worker.status === 'Created') && <Button variant="secondary" size="sm" type='button' title='Resend email' aria-label='Resend email' disabled={loading} className='workersDirectoryLinkButton workersDirectoryEmailIconButton' onClick={() => { handleResendSignUpEmail(worker) }}><MailIcon />Resend</Button>}
                                                        </TableCell>
                                                    </TableRow>
                                                })}
                                                {workersSort.sortedData.length === 0 && <TableEmpty  colSpan={5}>No workers yet.</TableEmpty>}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {workersSort.sortedData.length > 0 && <div className='invoicePagination'>
                                        <Button variant="secondary" size="md"
                                            type='button'
                                            disabled={workerDirectoryPage === 1}
                                            onClick={() => setWorkerDirectoryPage(currentPage => Math.max(1, currentPage - 1))}
                                        >
                                            Previous
                                        </Button>
                                        <span>Page {workerDirectoryPage} of {workerDirectoryPageCount}</span>
                                        <Button variant="secondary" size="md"
                                            type='button'
                                            disabled={workerDirectoryPage === workerDirectoryPageCount}
                                            onClick={() => setWorkerDirectoryPage(currentPage => Math.min(workerDirectoryPageCount, currentPage + 1))}
                                        >
                                            Next
                                        </Button>
                                    </div>}
                                </Section>
                            ) : (!showingWorkerAllocations &&
                                <Section
                                    title={activeOrg && activeOrg.role === 'admin' ? 'Workers' : 'My Details'}
                                    className='width-100 workerProfileCard workerProfileSummaryCard'
                                    variant='card'
                                >
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableHeaderCell {...workersSort.getSortableHeaderProps('firstName')}>
                                                    Name
                                                </TableHeaderCell>
                                                <TableHeaderCell>
                                                    Number
                                                </TableHeaderCell>
                                                <TableHeaderCell className='workerProfileEmailColumn'>
                                                    Email
                                                </TableHeaderCell>
                                                <TableHeaderCell>
                                                    Status
                                                </TableHeaderCell>
                                                <TableHeaderCell>
                                                    Action
                                                </TableHeaderCell>
                                            </TableRow>
                                        </TableHead>
                                        <tbody>
                                            {workersSort.sortedData.map(worker => <TableRow
                                                key={worker.id}
                                                ref={(node) => {
                                                    if (node) {
                                                        workerRowRefs.current.set(worker.id, node)
                                                    } else {
                                                        workerRowRefs.current.delete(worker.id)
                                                    }
                                                }}
                                            >
                                                <TableCell
                                                    className='hover'
                                                    onClick={() => openWorkerPanel(worker)}
                                                >
                                                    <span className='allocationDateLink workerMyProfileName'>{formatWorkerName(formatName(`${formatName(worker.firstName) || ''} ${formatName(worker.lastName) || ''}`))}</span>
                                                </TableCell>
                                                <TableCell>{formatPhone(worker.contactNo)}</TableCell>
                                                <TableCell className='workerProfileEmailColumn'>{formatEmail(worker.email)}</TableCell>
                                                <TableCell>{worker.status || 'Created'}</TableCell>
                                                <TableCell className='workerProfileActionColumn'>
                                                    <Button data-action-tone="edit" variant="secondary" size="icon"  type='button' title='Edit profile' aria-label='Edit profile' className='workerProfileEditIconButton' onClick={() => openWorkerPanel(worker, true)}><EditIcon /></Button>
                                                    {isAdmin && needsReview(worker) && <Button variant="secondary" size="sm" disabled={loading} className='textButton' onClick={() => { handleApproveReview(worker) }}>Approve</Button>}
                                                    {isAdmin && worker.archived && <Button variant="secondary" size="sm" disabled={loading} className='textButton' onClick={() => setConfirmMessage({ title: 'Restore Worker', message: 'Restore this archived worker to active lists and dropdowns?', confirmLabel: 'Restore', action: () => handleRestoreWorker(worker) })}>Restore</Button>}
                                                    {activeOrg && activeOrg.role === 'admin' && worker.signupSource !== 'public' && (!worker.status || worker.status === 'Created') && <Button variant="secondary" size="sm" disabled={loading} className='textButton' onClick={() => { handleResendSignUpEmail(worker) }}>Resend Email</Button>}
                                                </TableCell>
                                            </TableRow>)}
                                            {workersSort.sortedData.length === 0 && <TableEmpty  colSpan={5}>No workers yet.</TableEmpty>}
                                        </tbody>
                                    </Table>
                                </Section>)}
                        </>}

                {activeOrg && userInfo && !viewingWorker && !viewTimeSheet && !showingWorkerAllocations && <>
                    <Section
                        title={isWorker ? 'My Leave' : 'Workers On Leave'}
                        className='width-100 workerLeavesSection'
                        variant='card'
                        collapsible={isAdmin}
                        expanded={workerLeavesAccordionExpanded}
                        onToggle={setWorkerLeavesAccordionExpanded}
                    >
                        <div className='listToolbar'>
                            <div className='allocationSegment'>
                                {[
                                    { key: 'upcoming', label: 'Upcoming' },
                                    { key: 'past', label: 'Past' },
                                ].map(tab => (
                                    <Tabs.Tab active={leaveTab === tab.key}
                                        key={tab.key}
                                        className={leaveTab === tab.key ? 'allocationSegmentButton allocationSegmentButtonActive' : 'allocationSegmentButton'}
                                        onClick={() => setLeaveTab(tab.key)}
                                    >
                                        {tab.label}
                                    </Tabs.Tab>
                                ))}
                            </div>
                            {(isWorker || isAdmin) && (
                                <Button variant="create" size="md"
                                    className='allocationNewButton workerLeaveAddButton'
                                    onClick={() => { clearLeaveForm(); setShowLeaveForm(true) }}
                                >
                                    <PlusIcon />
                                    {isWorker ? 'Add My Leave' : 'Worker Leave'}
                                </Button>
                            )}
                        </div>

                        <ModalComponent
                            showModal={showLeaveForm}
                            setShowModal={(open) => {
                                if (!open) clearLeaveForm()
                            }}
                            customMaxWidth='400px'
                            customContentStyle={{ width: 'calc(100% - 32px)', minWidth: 0, padding: 0, overflow: 'hidden' }}
                        >
                            <div className='workerLeaveDialog'>
                                <div className='workerLeaveDialogHeader'>
                                    <h2>{editingLeave ? 'Edit Worker Leave' : 'Add Worker Leave'}</h2>
                                </div>
                                <div className='workerLeaveDialogBody'>
                                    {isAdmin && (
                                        <Dropdown
                                            options={workers.map(r => ({ label: formatName(`${r.firstName} ${r.lastName}`), value: r.id }))}
                                            value={leaveWorker}
                                            setValue={setLeaveWorker}
                                            label='Worker'
                                            disabled={!!editingLeave}
                                            required
                                        />
                                    )}
                                    <MyCalendar required showDateOnly noMaxDate dateFormat='EEE, d MMM' startDate={leaveStartDate} setStartDate={setLeaveStartDate} label='Leave Start' />
                                    <MyCalendar required showDateOnly noMaxDate dateFormat='EEE, d MMM' minDate={leaveStartDate || undefined} startDate={leaveEndDate} setStartDate={setLeaveEndDate} label='Leave End' />
                                    <Input label='Reason/Comments' value={leaveComments} setValue={setLeaveComments} />
                                </div>
                                <div className='workerLeaveDialogFooter'>
                                    <Button data-action-tone="cancel" variant="secondary" size="md"  type='button' className='secondaryButton' onClick={clearLeaveForm}>Cancel</Button>
                                    <Button data-action-tone="save" variant={editingLeave ? 'soft' : 'create'} size="md"  type='button' disabled={(isAdmin && !leaveWorker) || leaveLoading || !leaveStartDate || !leaveEndDate} onClick={handleSaveLeave}>
                                        {editingLeave ? 'Save' : 'Add Leave'}
                                    </Button>
                                </div>
                            </div>
                        </ModalComponent>

                        <div className='workerProfileTableWrap'><Table className={isWorker ? 'workersDirectoryTable workerProfileTable workerMyLeaveTable' : 'workersDirectoryTable workerProfileTable'}>
                            <TableHead>
                                <TableRow>
                                    {isAdmin && <TableHeaderCell {...workerLeavesSort.getSortableHeaderProps('workerName')}>
                                        Worker
                                    </TableHeaderCell>}
                                    <TableHeaderCell {...workerLeavesSort.getSortableHeaderProps('startDate')}>
                                        Start Date
                                    </TableHeaderCell>
                                    <TableHeaderCell {...workerLeavesSort.getSortableHeaderProps('endDate')}>
                                        End Date
                                    </TableHeaderCell>
                                    <TableHeaderCell>
                                        Reason/Comments
                                    </TableHeaderCell>
                                    <TableHeaderCell>
                                        Action
                                    </TableHeaderCell>
                                </TableRow>
                            </TableHead>
                            <tbody>
                                {workerLeaveRowsForDisplay.length === 0 ? (
                                    <TableEmpty  colSpan={leaveColumnCount}>No leaves yet.</TableEmpty>
                                ) : workerLeaveRowsForDisplay.map(leave => (
                                    <TableRow key={leave.id}>
                                        {isAdmin && <TableCell>{formatName(leave.workerName) ? formatWorkerName(formatName(leave.workerName)) : 'Unknown'}</TableCell>}
                                        <TableCell>{leave.startDate ? format(new Date(leave.startDate), 'EEE, d MMM yyyy') : ''}</TableCell>
                                        <TableCell>{leave.endDate ? format(new Date(leave.endDate), 'EEE, d MMM yyyy') : ''}</TableCell>
                                        <TableCell>{leave.comments || '-'}</TableCell>
                                        <TableCell className='workersDirectoryActionCell'>
                                            {(isAdmin || leave.workerId === userInfo?.id) && <Button data-action-tone="edit" variant="secondary" size="icon"  type='button' title='Edit leave' aria-label='Edit leave' className='textButton workerLeaveEditAction' onClick={() => handleEditLeave(leave)}><EditIcon /></Button>}
                                            {(isAdmin || leave.workerId === userInfo?.id) && <Button data-action-tone="delete" variant="danger" size="icon"  type='button' title='Delete leave' aria-label='Delete leave' className='textButton workerLeaveDeleteAction' disabled={leaveLoading} onClick={() => { setLeaveConfirmMessage({ message: 'Delete this leave?', action: () => handleDeleteLeave(leave) }) }}><TrashIcon /></Button>}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </Table></div>
                    </Section>

                    <ModalComponent
                        showModal={!!leaveConfirmMessage}
                        setShowModal={setLeaveConfirmMessage}
                        customMaxWidth='350px'
                        customContentStyle={{ width: 'calc(100% - 32px)', minWidth: 0, padding: '14px 16px' }}
                    >
                        <div className='workerLeaveDeleteConfirm'>
                            <h2 className='modalTitle'>Are you sure?</h2>
                            <p className='modalSubtitle'>{leaveConfirmMessage?.message}</p>
                            <div className='modalFooter'>
                                <Button data-action-tone="cancel" variant="secondary" size="md"  className='secondaryButton' onClick={() => setLeaveConfirmMessage(null)}>Cancel</Button>
                                <Button variant="danger" size="md" className='modalDangerButton' disabled={leaveLoading} onClick={() => leaveConfirmMessage?.action()}>Yes</Button>
                            </div>
                        </div>
                    </ModalComponent>
                </>}
            </PageContent>
        </div>
        <LoadingPopup
            visible={loading || uploading || sitePictureUploading || leaveLoading || openingDocument || fetchingDownload}
            message={fetchingDownload ? 'Downloading timesheet...' : openingDocument ? 'Opening document...' : uploading || sitePictureUploading ? 'Uploading...' : loadingMessage || 'Loading...'}
        />
    </div >)
}

export default WorkerProfile
